const deLocale = {
  'date.format': '{date, date, long}',
  test: `Testgebietsschema`,
  dashboard: `Armaturenbrett`,
  engage: `Engagieren`,
  assets: `Vermögenswerte`,
  submissions: `Einreichungen`,
  impact: `Auswirkungen`,
  programmes: `Programme`,
  interactions: `Interaktionen`,
  donations: `Spenden`,
  impact_strategy: `Impact-Strategie`,
  my_profile: `Mein Profil`,
  organisation: `Organisation`,
  users: `Benutzer`,
  profile: `Profil`,
  help: `Helfen`,
  logout: `Ausloggen`,
  insights: `Einblicke`,
  data: `Daten`,
  progress: `Fortschritt`,
  ideas: `Ideen`,
  reviewed: `Überprüft`,
  in_progress: `Im Gange`,
  pending_review: `Ausstehende Überprüfung`,
  most_popular_theme: `Beliebtestes Thema`,
  local_resident: `Anwohner`,
  local_business: `Lokales Geschäft`,
  charitable_group: `Wohltätigkeitsgruppe`,
  other_stakeholder: `Andere Stakeholder`,
  cultural: `Kulturell`,
  environmental: `Umwelt`,
  economic: `Wirtschaftlich`,
  educational: `Lehrreich`,
  social: `Sozial`,
  responder_types: `Respondertypen`,
  no_data_found: `Keine Daten gefunden`,
  most_popular_category: `Beliebteste Kategorie`,
  green_spaces: `Grünflächen`,
  local_tourism: `Lokaler Tourismus`,
  skills_development: `Kompetenzentwicklung`,
  other: `Andere`,
  most_popular_sub_category: `Beliebteste Unterkategorie`,
  grassland: `Wiese`,
  burgers: `Burger`,
  green_skills: `Grüne Kompetenzen`,
  filters: `Filter`,
  theme: `Thema`,
  category: `Kategorie`,
  sub_category: `Unterkategorie`,
  ideas_by_phase: `Ideen nach Phase`,
  oops: `Hoppla! Benutzername/Passwort sind möglicherweise falsch`,
  forgot_password: `Passwort vergessen?`,
  forgot_password_line1: `Wenn Sie ein Konto haben, haben Sie vom BizGive-Support eine E-Mail zum Zurücksetzen Ihres Passworts erhalten. Folgen Sie dem Link in dieser E-Mail, um ein neues Passwort zu erstellen.`,
  forgot_password_line2: `Bitte überprüfen Sie auch Ihren Spam-Ordner.`,
  forgot_password_line3: `Wenn Sie keine E-Mail erhalten, verfügen Sie möglicherweise nicht über ein aktives Konto. Bitte wenden Sie sich an den BizGive-Support.`,
  forgot_password_header: `Bitte überprüfen Sie Ihren Posteingang`,
  incorrect_email_id: `Bitte überprüfen Sie die eingegebene E-Mail-ID.`,
  forget_password: `Passwort vergessen`,
  forget_password_hint: `Bitte verwenden Sie mindestens 8 Zeichen, einen Groß- und Kleinbuchstaben, eine Zahl und ein Sonderzeichen.`,
  date_submitted: `Übermittlungsdatum`,
  feedback_type: `Feedback-Typ`,
  need: `Brauchen`,
  attributes: `Eigenschaften`,
  happy_to_be_contacted: `Möchten Sie kontaktiert werden?`,
  contact_information: `Kontaktinformationen`,
  the_sender_has_multiple_submissions: `Der Absender hat mehrere Einsendungen.`,
  actions: `Aktionen`,
  add_comment: `Kommentar hinzufügen`,
  date_actioned: `Datum der Aktion`,
  actioned_by: `Bearbeitet von`,
  back_to_map: `Zurück zur Karte`,
  submitter_type: `Einsendertyp`,
  submitter_location: `Standort des Einreichers`,
  submission_location: `Ort der Einreichung`,
  categories: `Kategorien`,
  yes: `Ja`,
  no: `NEIN`,
  save: `Speichern`,
  idea_location: `Ideenstandort`,
  please_populate: `Bitte füllen Sie`,
  comments_added_successfully: `Kommentare erfolgreich hinzugefügt`,
  see_location: `Siehe Standort`,
  feedback: `Rückmeldung`,
  feedback_by_phase: `Feedback nach Phase`,
  feedback_location: `Feedback-Standort`,
  comment: `Kommentar`,
  asset: `Vermögenswert`,
  phase: `Phase`,
  idea: `Idee`,
  submitter: `Einsender`,
  requestedContact: `Kontakt gewünscht?`,
  collaborate: `Zusammenarbeiten`,
  contact_by_phase: `Kontakt nach Phase`,
  collaborate_location: `Standort der Zusammenarbeit`,
  number_of_employees: `Anzahl Mitarbeiter`,
  global_annual_turnover: `Weltweiter Jahresumsatz (£ Mio.)`,
  industry: `Industrie`,
  services_provided: `Angebotene Leistungen`,
  services_description: `Beschreibung der Dienste`,
  renewable_experience: `Erneuerbare Erfahrung?`,
  requested_introduction_to_tier_one_contractors: `Einführung in Tier-1-Auftragnehmer gewünscht?`,
  organization_name: `Name der Organisation`,
  select_a_row_to_make_an_offer: `Wählen Sie eine Zeile aus, um ein Angebot abzugeben`,
  website: `Webseite`,
  overview: `Überblick`,
  project_reports: `Projektberichte`,
  total_visitors: `Besucher insgesamt`,
  feedback_submitted: `Feedback gesendet`,
  ideas_submitted: `Eingereichte Ideen`,
  collaborations_submitted: `Eingereichte Kooperationen`,
  pending_actions: `Ausstehende Aktionen`,
  three_month_historical_visitors: `Historische Besucher der letzten 3 Monate`,
  submission_type: `Übermittlungstyp`,
  collaborations: `Kooperationen`,
  applications: `Anwendungen`,
  action_required: `Erforderliche Aktion`,
  pending_response: `Ausstehende Antwort`,
  pre_approved: `Vorab genehmigt`,
  approved: `Genehmigt`,
  declined: `Abgelehnt`,
  your_session_will_expire_in: `Ihre Sitzung läuft ab in…`,
  select_whether_you_would_like_to_stay_logged_in_or_log_out: `Wählen Sie, ob Sie angemeldet bleiben oder sich abmelden möchten. Wenn Sie nichts tun, werden Sie aus Sicherheitsgründen automatisch abgemeldet.`,
  stay_logged_in: `Angemeldet bleiben`,
  log_out: `Abmelden`,
  all_phases: `Alle Phasen`,
  login: `Login`,
  not_registered_yet: `Noch nicht angemeldet?`,
  sign_up: `Melden Sie sich an`,
  user_terms: `Nutzungsbedingungen`,
  privacy_policy: `Datenschutzrichtlinie`,
  create_an_account_to_apply_for_support: `Erstellen Sie ein Konto, um Support zu beantragen`,
  are_you_impact_funder_contact_us: `Sind Sie ein Impact-Fundeur? Kontaktieren Sie uns`,
  confirm_password: `Passwort bestätigen`,
  password_must_include: `Das Passwort muss Folgendes enthalten:`,
  more_than_eight_characters: `- Mehr als 8 Zeichen`,
  an_upper_and_lower_case_character: `- Ein Groß- und ein Kleinbuchstabe`,
  a_number: `- Eine Nummer`,
  a_special_character: `- Ein besonderes Zeichen`,
  i_accept_the: `Ich akzeptiere die`,
  register: `Registrieren`,
  connect_with_funders_and_design_your_opportunities_to_create_positive_impact: `Knüpfen Sie Kontakte zu Geldgebern und gestalten Sie Ihre Möglichkeiten, positive Auswirkungen zu erzielen`,
  or_login_to_create_your_free_BizGive_account: `oder melden Sie sich an, um Ihr kostenloses BizGive-Konto zu erstellen.`,
  discover: `Entdecken`,
  funding_programmes_and_create_a_profile_to_receive_alerts: `Förderprogramme und erstellen Sie ein Profil, um Benachrichtigungen zu erhalten.`,
  submit: `Einreichen`,
  applications_auto_verified_against_funder_criteria: `Anträge werden automatisch anhand der Kriterien des Geldgebers überprüft.`,
  share: `Aktie`,
  content_track_impact_and_capture_funder_feedback: `Inhalte, Wirkungsverfolgung und Erfassung von Feedback von Geldgebern.`,
  here: `Hier`,
  please_enter_password: `Bitte geben Sie das Passwort ein`,
  ok: `OK`,
  confirm_email: `E-Mail bestätigen`,
  log_in: `Einloggen`,
  please_enter_email: `Bitte geben Sie eine E-Mail-Adresse ein`,
  the_input_is_not_valid_email: `Die eingegebene E-Mail ist ungültig!`,
  the_new_password_that_you_entered_do_not_match: `Das von Ihnen eingegebene neue Passwort stimmt nicht überein!`,
  the_new_email_that_you_entered_do_not_match: `Die von Ihnen eingegebene neue E-Mail stimmt nicht überein!`,
  please_confirm_your_password: `Bitte geben Sie das Kennwort ein.`,
  please_accept_the_user_terms: `Bitte akzeptieren Sie die Nutzungsbedingungen`,
  change_password: `Kennwort ändern`,
  password: `Passwort`,
  we_just_emailed: `Wir haben gerade eine E-Mail geschickt`,
  please_click_on_the_link_in_your_email_to_activate_your_account: `Klicken Sie bitte auf den Link in Ihrer E-Mail, um Ihr Konto zu aktivieren`,
  please_enter_a_valid_password: `Bitte geben Sie ein gültiges Passwort ein`,
  you_have_been_logged_out_due_to_inactivity: `Sie wurden aufgrund von Inaktivität abgemeldet …`,
  please_enter_a_valid_password_using_the_guidance_below: `Fehler – Bitte geben Sie anhand der folgenden Anleitung ein gültiges Passwort ein.`,
  entity: `Juristische Person`,
  unique_visitors: `Einzigartige Besucher`,
  questions: `Fragen`,
  localQuestions: `Lokale Fragen`,
  visitors: `Besucher`,
  visitor_id: `Besucher-ID`,
  answer: `Antwort`,
  question_time: `Fragestunde`,
  avg_question_per_visitor: `Durchschnittliche Fragen pro Besucher`,
  media: `Medien`,
  logo: `Logo`,
  profile_create: `Profil erstellen`,
  lets_get_started: `Lass uns anfangen`,
  name_and_location: `Name und Ort`,
  what_is_the_legal_Name_of_your_entity: `Wie lautet der rechtliche Name Ihres Unternehmens?`,
  what_entity_name_would_like_to_be_displayed: `Welcher Entitätsname soll angezeigt werden?`,
  what_is_your_registered_address: `Wie lautet Ihre registrierte Adresse?`,
  description: `Beschreibung`,
  add_your_description: `Fügen Sie Ihre Beschreibung hinzu`,
  add_your_social_media_details: `Fügen Sie Ihre Social-Media-Details hinzu`,
  what_is_your_website: `Was ist Ihre Website?`,
  optional: `Optional`,
  add_your_company_logo: `Fügen Sie Ihr Firmenlogo hinzu`,
  upload: `Hochladen`,
  organization_profile: `Profil der Organisation`,
  description_company: `Beschreibung`,
  detail: `Detail`,
  registered_address: `Registrierte Adresse`,
  proceed: `Fortfahren`,
  previous: `Vorherige`,
  save_n_exit: `Speichern und beenden`,
  next: `Nächste`,
  enter: `Eingeben`,
  complete: `Vollständig`,
  my_details: `Meine Angaben`,
  your_name: `Ihr Name`,
  phone_number: `Telefonnummer`,
  job_title: `Berufsbezeichnung`,
  biz_give_role: `BizGive-Rolle`,
  member_since: `Mitglied seit`,
  my_programmes: `Meine Programme`,
  delete_file_confirmation: `Bestätigung zum Löschen der Datei`,
  please_confirm_you_are_happy_to_permanently_delete_this_file: `Bitte bestätigen Sie, dass Sie mit der dauerhaften Löschung dieser Datei einverstanden sind.`,
  delete: `Löschen`,
  cancel: `Stornieren`,
  create_password: `Passwort erstellen`,
  invite_new_user: `Neuen Benutzer einladen`,
  regular_users: `Normale Benutzer`,
  can_not_view_or_edit_anything_by_default: `Standardmäßig können keine Inhalte angezeigt oder bearbeitet werden. Alle eingeladenen Benutzer haben diesen Status. Sie können sie zu Programmen hinzufügen, um das jeweilige Programm und die zugehörigen Inhalte anzuzeigen und/oder zu bearbeiten.`,
  organization_admins: `Organisationsadministratoren`,
  can_access_and_edit_everything_in_the_platform: `kann auf alle Elemente der Plattform zugreifen und diese bearbeiten. Sie können auf diesem Bildschirm bestehenden Benutzern dieses Recht zuweisen.`,
  user_name: `Benutzername`,
  make_admin: `Zum Administrator machen`,
  remove_admin: `Administrator entfernen`,
  invited: `EINGELADEN`,
  regular: `REGULÄR`,
  admin: `VERWALTUNG`,
  remove_user_from_your_organization: `Benutzer aus Ihrer Organisation entfernen`,
  please_confirm_you_are_to_permanently_remove_this_user: `Bitte bestätigen Sie, dass Sie diesen Benutzer dauerhaft entfernen möchten.`,
  none_of_their_programmes_or_interaction_data_will_be_removed: `Keine ihrer Programme oder Interaktionsdaten werden entfernt`,
  remove_user: `Benutzer entfernen`,
  remove_admin_rights: `Administratorrechte entfernen`,
  remove: `Entfernen`,
  as_an_Organization_Admin: `als Organisationsadministrator.`,
  they_will_then_only_be_able_to_view_and_edit_programmes_that_they_manage: `Sie können dann nur noch die von ihnen verwalteten Sendungen ansehen und bearbeiten.`,
  enter_email_address: `E-Mail-Adresse eingeben`,
  confirm_email_address: `E-Mail-Adresse bestätigen`,
  invite: `Einladen`,
  add_admin_rights: `Administratorrechte hinzufügen`,
  make: `Machen`,
  an_organization_admin: `ein Organisationsadministrator`,
  they_will_be_able_to_view_and_edit_everything_in_your_organization: `Sie können alles in Ihrer Organisation anzeigen und bearbeiten.`,
  charity_can_not_view_or_edit_anything_by_default: `Standardmäßig können keine Inhalte angezeigt oder bearbeitet werden. Alle eingeladenen Benutzer haben diesen Status. Sie können sie zu Anwendungen hinzufügen, um diese und zugehörige Inhalte anzuzeigen und/oder zu bearbeiten.`,
  charity_can_access_and_edit_everything_in_the_platform: `kann auf alle Elemente der Plattform zugreifen und diese bearbeiten. Sie können auf diesem Bildschirm bestehenden Benutzern dieses Recht zuweisen.`,
  none_of_their_applications_or_interaction_data_will_be_removed: `Keine ihrer Anwendungen oder Interaktionsdaten werden entfernt`,
  they_will_then_only_be_able_to_view_and_edit_applications_that_they_manage: `Sie können dann nur die von ihnen verwalteten Anwendungen anzeigen und bearbeiten.`,
  the_invited_user_already_has_an_account_linked_to_this_email_address: `Der eingeladene Benutzer hat bereits ein Konto, das mit dieser E-Mail-Adresse verknüpft ist. Bitte überprüfen Sie Ihre Benutzerliste oder wenden Sie sich an BizGive, um Unterstützung zu erhalten.`,
  all_programmes: `Alle Programme`,
  download: `Herunterladen`,
  search_placeholder: `Suchen...`,
  actions_required: `Erforderliche Aktionen`,
  opportunity: `Gelegenheit`,
  date_applied: `Bewerbungsdatum`,
  date_requested: `Angefordertes Datum`,
  net_vote: `Nettostimmen (Wähler)`,
  date_approved: `Genehmigungsdatum`,
  date_declined: `Datum der Ablehnung`,
  applied: `ANGEWANDT`,
  in_edit: `IN BEARBEITUNG`,
  pre_approved_caps: `Vorab genehmigt`,
  approved_caps: `GENEHMIGT`,
  declined_caps: `ABGELEHNT`,
  review: `Rezension`,
  customize_your_download: `Passen Sie Ihren Download an`,
  select_application_status: `Bewerbungsstatus auswählen`,
  share_and_manage_voting: `Teilen und Verwalten von Abstimmungen`,
  current_share_access_closing_date: `Aktueller Aktienzugangsschluss`,
  invited_users_will_receive_an_email_with_access_details: `Eingeladene Nutzer erhalten eine E-Mail mit Zugangsdaten, die bis zum Einsendeschluss verfügbar sind. Sie können nur ihre Stimmen einsehen.`,
  invited_voters: `Eingeladene Wähler`,
  add_email_address: `E-Mail-Adresse hinzufügen`,
  reported_grants: `Gemeldete Zuschüsse`,
  planned_grants: `Geplante Zuschüsse`,
  remaining_budget: `Verbleibendes Budget`,
  total_budget: `Gesamtbudget`,
  do_you_wish_to_request_indicators: `Möchten Sie Indikatoren anfordern?`,
  the_entity_will_be_asked_to_create: `Das Unternehmen wird aufgefordert, Indikatoren für seine Chance zu erstellen, die auf ausgewählte Ergebnisse abgestimmt sind.`,
  please_confirm_you_wish_to_complete_this_item: `Dieser Schritt ist abgeschlossen.`,
  requested: `Angefordert`,
  do_you_wish_the_applicant_to_create_indicators_to_measure_its_progress: `Wünschen Sie, dass der Antragsteller Indikatoren zur Messung seines Fortschritts erstellt?`,
  volunteering: `Freiwilligenarbeit`,
  day: `Tag`,
  inkind: `Sachleistungen`,
  budget_period_end: `Ende des Budgetzeitraums`,
  offer_mode: `Angebotsmodus`,
  select_a_row_to_make_an_ofter: `Wählen Sie eine Zeile aus, um ein Angebot zu machen`,
  total_requests: `Anfragen insgesamt`,
  remaining_budget_minus_requests: `Verbleibendes Budget (abzüglich Anfragen)`,
  remaining_budget_with_offers: `Verbleibendes Budget (mit Angeboten)`,
  save_offers: `Angebote sichern`,
  send_selected_offers: `Ausgewählte Angebote senden`,
  send_offers_confirmation: `Angebotsbestätigung senden`,
  clicking_send_will_send_the_following_message_and_enable_editing_to_all_projects_that_you_have_selected_in_the_table: `Wenn Sie auf „Senden“ klicken, wird die folgende Nachricht gesendet und die Bearbeitung aller Projekte aktiviert, die Sie in der Tabelle ausgewählt haben:`,
  congratulations_we_would_like_to_approve_your_project: `Herzlichen Glückwunsch, wir möchten Ihr Projekt mit dem folgenden Betrag [Währungssymbol]XXXX genehmigen. Wenn dies angemessen ist, bearbeiten Sie bitte Ihr Projekt, um die Ausgabenänderung und die Auswirkungen anzuzeigen.`,
  no_rounds_available: `Nicht verfügbar`,
  please_fill_all_offers: `Bitte füllen Sie alle Angebote aus`,
  offers_sent_successfully: `Angebote erfolgreich versendet`,
  offers_saved_successfully: `Angebote erfolgreich gespeichert`,
  offer: `Angebot`,
  budget_available: `Verfügbares Budget`,
  budget_amount: `Budgetbetrag`,
  remaining: `Übrig`,
  select_filter: `Bitte wählen Sie einen Filter`,
  donation_title: `Spende`,
  email_id_title: `E-Mail-ID`,
  add_user: `Benutzer hinzufügen`,
  delete_title: `Löschen`,
  add_title: `Hinzufügen`,
  delete_user: `Benutzer löschen`,
  action_cannot_undone: `Diese Aktion kann nicht rückgängig gemacht werden. Alle von ihnen verwalteten Opportunities sind für Kontoadministratoren weiterhin zugänglich.`,
  confirm_title: `Bestätigen`,
  adding_admin_rights: `Durch das Hinzufügen von Administratorrechten kann der Benutzer Möglichkeiten erstellen, das Organisationsprofil aktualisieren, Benutzer hinzufügen und entfernen sowie Administratoren erstellen.`,
  remove_admin_rights_para: `Durch das Entfernen der Administratorrechte kann der Benutzer keine Möglichkeiten mehr erstellen, das Organisationsprofil aktualisieren, Benutzer hinzufügen und entfernen und Administratoren erstellen.`,
  save_private: `Gespeichert (privat)`,
  planned_shared: `Geplant (Geteilt)`,
  invoice_requested: `Rechnung angefordert`,
  invoice_received: `Rechnung erhalten`,
  reported_title: `Gemeldet`,
  confirmed_title: `Bestätigt`,
  report_donation: `Spende melden`,
  cancel_title: `Stornieren`,
  save_title: `Speichern`,
  grant: `Gewähren`,
  awarded: `Ausgezeichnet`,
  award_title: `Vergeben`,
  type_title: `Typ`,
  invoice_title: `Rechnung`,
  condition_title: `Zustand`,
  reported_date_title: `Meldedatum`,
  next_action_title: `Nächste Aktion`,
  donation_created: `Erfolg – ​​Spende erstellt`,
  donation_updated: `Erfolgreich – Spende aktualisiert`,
  donation_deleted: `Erfolg – ​​Spende gelöscht`,
  view_donation: `Spende ansehen`,
  select_title: `Wählen`,
  approved_opportunities_planned_impact: `Genehmigte Möglichkeiten (geplante Auswirkungen)`,
  achieved_impact: `Erzielte Wirkung (abgeschlossene Gelegenheiten)`,
  achieved_beneficiaries: `Erreichte Begünstigte`,
  outputs_achieved: `Erreichte Ergebnisse`,
  content_received: `Erhaltener Inhalt (erzielte Wirkung)`,
  opportunity_name: `Name der Gelegenheit`,
  entity_name: `Entitätsname`,
  due_date: `Fälligkeitsdatum`,
  number: `Nummer`,
  approved_date: `Genehmigungsdatum`,
  view: `Sicht`,
  primary_UN_SDG: `Primäres UN-SDG`,
  opportunity_type: `Gelegenheitstyp`,
  charity_name: `Name der Wohltätigkeitsorganisation`,
  select_type: `Bitte wählen Sie einen Typ`,
  please_fill_amount: `Bitte Betrag eintragen`,
  enter_title: `Eingeben`,
  please_enter_conditions: `Bitte geben Sie den Zustand ein`,
  please_select_action: `Bitte wählen Sie eine Aktion aus`,
  actions_title: `Aktionen`,
  select_action: `Aktion auswählen`,
  payment_reference: `Zahlungsreferenz`,
  please_select_amount: `Bitte wählen Sie einen Betrag`,
  enter_payment_reference: `Zahlungsreferenz eingeben`,
  upload_counterpart_behalf: `Rechnung im Namen des Gegenübers hochladen`,
  equivalent_value: `Äquivalenter Wert`,
  amount_title: `Menge`,
  purchase_order: `Auftragsbestätigung`,
  files_title: `Dateien`,
  company_name_title: `Name der Firma`,
  programme_type_title: `Programmtyp`,
  application_start_date: `Bewerbungsbeginn`,
  application_end_date: `Bewerbungsschluss`,
  location_title: `Standort`,
  next_update_outcome: `Nächstes Update / Ergebnis`,
  donations_by: `Spenden von`,
  decision_date: `Datum der Entscheidung`,
  decision_start_date: `Entscheidungsbeginn`,
  decision_end_date: `Enddatum der Entscheidung`,
  opportunity_i_manage: `Von mir verwaltete Chancen`,
  select_template: `Vorlage auswählen`,
  please_select_template: `Bitte wählen Sie eine Vorlage aus`,
  save_draft: `Entwurf speichern`,
  all_opportunities: `Alle Möglichkeiten`,
  excel_title: `Excel`,
  budget_period: `Budgetperiode`,
  latest_period: `Letzter Zeitraum`,
  select_donation_status: `Spendenstatus auswählen`,
  delete_file: `Datei löschen`,
  deleting_file_para: `Durch das Löschen dieser Datei wird sie dauerhaft entfernt`,
  delete_donation: `Spende löschen`,
  delete_donation_para: `Durch das Löschen dieser Spende werden alle zugehörigen Informationen dauerhaft gelöscht`,
  cancel_changes: `Änderungen verwerfen`,
  remove_title: `Entfernen`,
  will_remove_changes_to_donation: `Dadurch werden alle an der Spende vorgenommenen Änderungen gelöscht`,
  edit_title_uppercase: `BEARBEITEN`,
  current_report_period: `Aktueller Berichtszeitraum`,
  current_report_open: `Aktueller Bericht geöffnet`,
  current_report_close: `Aktueller Bericht Schließen`,
  manage_title: `Verwalten`,
  open_date: `Öffnungsdatum`,
  close_date: `Schlusstermin`,
  period_title: `Zeitraum`,
  reporter_title: `Reporter`,
  edit_title: `Bearbeiten`,
  about_me: `Über mich`,
  please_enter_valid_name: `Bitte geben Sie einen gültigen Namen ein`,
  please_enter_only_alphabets: `Bitte geben Sie nur Buchstaben ein`,
  name_Title: `Name`,
  phone_number_title: `Telefonnummer`,
  upload_purchase_order: `Bestellung hochladen`,
  programme_dates: `Programmdaten`,
  programme_start: `Studienbeginn`,
  programme_end: `Programmende`,
  currency: `Währung`,
  current_budget_year_end: `Ende des aktuellen Haushaltsjahres:`,
  approved_summary: `Genehmigte Zusammenfassung`,
  please_select_programme: `Bitte wählen Sie ein Programm`,
  generate: `Erzeugen`,
  opportunities_supported: `Unterstützte Möglichkeiten`,
  approved_opportunities: `Genehmigte Möglichkeiten`,
  planned_impact: `Geplante Auswirkungen (Genehmigte Möglichkeiten)`,
  grants: `Zuschüsse`,
  planned_beneficiaries: `Geplante Begünstigte`,
  direct: `Direkt`,
  indirect: `Indirekt`,
  primary: `Primär`,
  secondary: `Sekundär`,
  all: `Alle`,
  programme_name: `Programmname`,
  reset: `Zurücksetzen`,
  my_feedback: `Mein Feedback`,
  feedback_title: `Rückmeldung`,
  select_opportunity: `Chance auswählen`,
  please_select_opportunity: `Bitte wählen Sie eine Möglichkeit aus`,
  select_report: `Bericht auswählen`,
  please_select_report: `Bitte wählen Sie einen Bericht aus`,
  editing_title: `Bearbeitung`,
  enabled_title: `Ermöglicht`,
  locked_title: `Gesperrt`,
  content_title_uppercase: `INHALT`,
  feedback_title_uppercase: `RÜCKMELDUNG`,
  no_data: `Keine Daten`,
  program_status: `Programmstatus`,
  un_sdgs: `UN-Nachhaltigkeitsziele`,
  more_title: `Mehr`,
  program_location: `Programmstandort`,
  asset_name: `Assetname`,
  asset_location: `Anlagenstandort`,
  portfolio_title: `Portfolio`,
  review_title: `Rezension`,
  payment_date: `Zahlungstermin`,
  secondary_UN_SDG: `Sekundäre UN-SDGs`,
  summary_title: `Zusammenfassung`,
  select_the_programme_you_wish_to_receive: `Wählen Sie das Programm aus, für das Sie einen Bericht zum oben ausgewählten Vermögenswert erhalten möchten.`,
  manager: `Manager`,
  add_managers_who_can_invite_reporter: `Fügen Sie Manager hinzu, die in Ihrem Namen Reporter einladen können. Hinweis: Interne Benutzer Ihrer Organisation können über Ihre`,
  admin_page: `Admin-Seite`,
  inviting_existing_user: `Vorhandene Benutzer einladen`,
  invite_new: `Neue einladen`,
  external_users: `Externe Benutzer`,
  by_entering_their_email_address: `durch Eingabe ihrer E-Mail-Adresse`,
  optional_add_reporters: `Optional. Fügen Sie Reporter hinzu, die Programmberichte für Ihre Assets erstellen.`,
  manage_report: `Bericht verwalten`,
  add_asset: `Asset hinzufügen`,
  budget_history: `Budgetverlauf`,
  milestones: `Meilensteine`,
  programme_name_title: `Programmname`,
  application: `Anwendung`,
  create: `Erstellen`,
  comment_title: `Kommentar`,
  cash_donation_saved_successfully: `Geldspende gespart.`,
  upload_invoice: `Rechnung hochladen`,
  upload_title: `Hochladen`,
  confirm_receipt: `Empfang bestätigen`,
  received_title: `Erhalten`,
  please_confirm_donation_received: `Bitte bestätigen Sie den Eingang dieser Spende.`,
  success_donation_received: `Erfolg - Spende erhalten`,
  success_invoice_uploaded: `Erfolgreich – Rechnung hochgeladen`,
  click_to_upload: `Zum Hochladen klicken`,
  settings: `Einstellungen`,
  internal_only: `Nur intern`,
  visibility_title: `Sichtweite`,
  public_title: `Öffentlich`,
  private: `Privat`,
  completed: `Vollendet`,
  content_package: `Inhaltspaket`,
  please_select_interaction_status: `Bitte wählen Sie den Interaktionsstatus aus.`,
  go_back: `Geh zurück`,
  budget_dates: `Haushaltstermine`,
  budget_recurring: `Budget wiederkehrend?`,
  objectives: `Ziele`,
  supporting_materials: `Unterstützendes Material`,
  web_links: `Weblinks`,
  administrators: `Administratoren`,
  application_criteria: `Bewerbungskriterien`,
  documentation_required: `Erforderliche Dokumentation`,
  available_support: `Verfügbarer Support`,
  none: `Keiner`,
  eligibility_checklist: `Checkliste zur Berechtigung`,
  location_supported: `Standort unterstützt`,
  project_must_be_within: `Das Projekt muss innerhalb`,
  of_this_location: `dieses Ortes`,
  expand_all: `Alles erweitern`,
  entities_supported: `Unterstützte Entitäten`,
  mandatory: `Obligatorisch`,
  expected_budget: `Erwartetes Budget`,
  per_opportunity: `Pro Projekt`,
  specific_skills_available: `Spezifische Fähigkeiten verfügbar`,
  general_skills_available: `Verfügbare allgemeine Fähigkeiten`,
  any: `Beliebig`,
  application_accepted_between: `Bewerbungen akzeptiert`,
  donation_to_be_made_between: `Zu leistende Spende`,
  interim_update_requested: `Zwischenupdate angefordert`,
  final_report_requested: `Abschlussbericht angefordert`,
  show_all_goals: `Alle Ziele anzeigen`,
  any_location: `Jeder Ort`,
  apply: `Anwenden`,
  eligibility: `Teilnahmeberechtigung`,
  before_applying_please_confirm_your_eligibility: `Bitte bestätigen Sie vor der Bewerbung Ihre Eignung:`,
  please_confirm_that_your_project_is_located_within_or_that_it_benefits_those_within_the_supported_locations: `Bitte bestätigen Sie, dass Ihr Projekt an den unterstützten Standorten angesiedelt ist oder den Menschen dort zugute kommt.`,
  please_select: `Bitte wählen`,
  project_description: `Projektbeschreibung`,
  please_share_a_summary_of_your_project: `Bitte teilen Sie eine Zusammenfassung Ihres Projekts mit`,
  enter_project_summary: `Projektzusammenfassung eingeben`,
  please_describe_your_project: `Bitte beschreiben Sie Ihr Projekt`,
  for_example_what_do_you_want_to_do: `Was möchten Sie beispielsweise tun, wie werden Sie dies tun, haben Sie einen Bedarf für das Projekt festgestellt und wer wird es leiten?`,
  this_application_is_to: `Diese Anwendung dient dazu:`,
  application_accepted: `Bewerbungen werden akzeptiert:`,
  application_sections: `Anwendungsbereiche`,
  application_preview: `Anwendungsvorschau`,
  application_guidance: `Anwendungshinweise`,
  in_the_application_form: `Im Antragsformular werden Sie gebeten, Einzelheiten zu einem Projekt anzugeben, für das Sie eine Finanzierung beantragen.`,
  next_title: `'Nächste'`,
  save_n_exit_title: `„Speichern & Beenden“`,
  submit_title: `'Einreichen'`,
  saves_your_data_and_moves: `speichert Ihre Daten und leitet Sie zum nächsten Bildschirm im Bewerbungsformular weiter. Ihre Antworten werden automatisch gespeichert, sofern Sie kein Problem mit der Internetverbindung haben.`,
  saves_your_data_and_closes: `speichert Ihre Daten und schließt das Antragsformular, damit Sie später darauf zurückkommen können. Sie müssen alle erforderlichen Felder ausfüllen, um „Speichern & Beenden“ zu wählen (Sie können beliebige Werte eingeben, z. B. X als Platzhalter, um`,
  saves_your_data_and_closes_the_report: `Speichert Ihre Daten und schließt den Bericht, damit Sie später darauf zurückgreifen können. Füllen Sie alle erforderlichen Felder aus, um „Speichern & Beenden“ zu aktivieren (Sie können beliebige Werte, z. B. X, als Platzhalter eingeben).`,
  sends_your_application_form_to_the_company: `sendet Ihr Bewerbungsformular an das Unternehmen. Diese Schaltfläche erscheint auf dem letzten Bildschirm des Bewerbungsformulars.`,
  to_access_a_saved_application: `So greifen Sie auf eine gespeicherte Anwendung zu: Klicken Sie auf „Anwendungen“ und dann auf „Erforderliche Aktion“.`,
  to_view_a_submitted_application: `So zeigen Sie eine eingereichte Bewerbung an: Klicken Sie auf „Bewerbungen und ausstehende Antworten“.`,
  start: `Start`,
  application_form: `Antragsformular`,
  your_application: `Ihre Bewerbung`,
  what_is_the_name_of_your_project: `Wie heißt Ihr Projekt?`,
  please_complete_each_screen: `Bitte füllen Sie alle Felder des Bewerbungsformulars aus. Auf der letzten Seite sehen Sie eine Vorschau Ihrer Bewerbung. Klicken Sie hier auf „Senden“, um sie an das Unternehmen zu senden.`,
  project_name: `Projektname`,
  add_a_banner_image: `Fügen Sie ein Bannerbild hinzu`,
  this_will_show_at_the_top_of_your_application_form: `Dies wird oben auf Ihrem ausgefüllten Bewerbungsformular angezeigt.`,
  choose_an_image_from_bizGive: `Wählen Sie ein Bild von BizGive`,
  upload_your_own_banner_image: `Laden Sie Ihr eigenes Bannerbild hoch`,
  additional_images: `Weitere Bilder`,
  bizGive_images: `BizGive-Bilder`,
  where_is_your_project_located: `Wo befindet sich Ihr Projekt?`,
  search_for_and_select_the_address_of_your_location: `Suchen Sie nach der Adresse Ihres/Ihrer Standorte(s) und wählen Sie diese aus. Oder alternativ:`,
  click: `klicken`,
  any_place_or_point_on_the_map_to_select_it: `Wählen Sie einen beliebigen Ort oder Punkt auf der Karte aus.`,
  add_or_Edit_the_name_for_your_location_and_press: `Fügen Sie den Namen für Ihren Standort hinzu oder bearbeiten Sie ihn und drücken Sie „Weitere hinzufügen“, um weitere Standorte hinzuzufügen.`,
  add_additional_location: `Weiteren Standort hinzufügen`,
  one_or_more_project_locations_are_located_outside_of_the_programme_area: `Ein oder mehrere Projektstandorte liegen außerhalb des Programmgebiets.`,
  please_change_your_project_location_or_explain_how_your_project_will_benefit_the_programme_area_below: `Bitte ändern Sie Ihren Projektstandort ODER erklären Sie unten, wie Ihr Projekt dem Programmbereich zugute kommt`,
  how_will_it_benefit_the_programme_area: `Welchen Nutzen wird es dem Programmgebiet bringen?`,
  project_dates: `Projektdaten`,
  when_is_your_project_happening: `Wann findet Ihr Projekt statt?`,
  this_can_be_an_estimate: `Dies kann eine Schätzung sein, da Sie bei erfolgreicher Bewerbung aufgefordert werden, Ihre Daten zu ändern oder zu bestätigen.`,
  projects_must_start_within_12_months: `Projekte müssen innerhalb von opportunityStartWithinMonths Monaten beginnen.`,
  projects_must_not_be_longer_than_6_months: `Projekte dürfen nicht länger als opportunityLengthMonths Monate dauern.`,
  estimated_start: `Voraussichtlicher Beginn`,
  estimated_finish: `Voraussichtliches Ende`,
  is_there_a_deadline_when_you_need_to_receive_a_donation_by: `Gibt es eine Frist, bis zu der Sie eine Spende erhalten müssen, damit Ihr Projekt durchgeführt werden kann?`,
  if_not_please_leave_this_blank: `Wenn nicht, lassen Sie dieses Feld bitte leer.`,
  enter_date: `Datum eingeben`,
  what_support_are_you_applying_for: `Welche Förderung beantragen Sie?`,
  in_kind: `In Form von Sachleistungen`,
  how_much_are_you_applying_for: `Wie viel beantragen Sie?`,
  enter_amount: `Betrag eingeben`,
  how_much_does_your_project_cost_in_total: `Wie viel kostet Ihr Projekt insgesamt?`,
  you_are_applying_for_percentage_of_the_total_cost_of_your_project: `Sie beantragen einen Prozentsatz der Gesamtkosten Ihres Projekts`,
  how_will_you_use_any_support_awarded: `Wie werden Sie die gewährte Unterstützung verwenden?`,
  enter_number_of_items_or_activity: `Geben Sie die Anzahl der Artikel oder die Aktivität ein`,
  enter_description: `Beschreibung eingeben`,
  where_will_additional_funds_come_from: `Woher sollen die zusätzlichen Mittel kommen?`,
  internal_resources: `Interne Ressourcen`,
  external_funding: `Externe Förderung`,
  have_you_already_secured_this_funding: `Haben Sie diese Finanzierung bereits gesichert?`,
  can_your_project_proceed_if_you: `Kann Ihr Projekt fortgesetzt werden, wenn Sie diese zusätzlichen Mittel nicht sichern?`,
  what_outputs_will_the_support_help_you_to_achieve: `Welche Ergebnisse können Sie mithilfe der Unterstützung erreichen?`,
  your_outputs_will_show_like_this_in_your_application_form: `Ihre Ergebnisse werden in Ihrem Bewerbungsformular wie folgt angezeigt:`,
  what_items_or_services_do_you_need: `Welche Artikel oder Dienstleistungen benötigen Sie?`,
  for: `für`,
  what_volunteering_support_do_you_need: `Welche ehrenamtliche Unterstützung benötigen Sie?`,
  edit_image: `Bild bearbeiten`,
  change_image: `Bild ändern`,
  delete_image: `Bild löschen`,
  click_delete_to_remove_this_image: `Klicken Sie auf „Löschen“, um dieses Bild zu entfernen.`,
  option: `Option`,
  add: `Hinzufügen`,
  tips: `Tipps`,
  what_is_an_output: `Was ist eine Ausgabe?`,
  an_output_is_what_you_expect_to_achieve_from_the_support_awarded_below_are_some_examples: `Ein Ergebnis ist das, was Sie von der gewährten Unterstützung erwarten. Nachfolgend einige Beispiele:`,
  number_new_teaching_assistants_trained: `5 neue Lehrassistenten ausgebildet`,
  number_new_teachers_trained: `10 neue Lehrer ausgebildet`,
  number_workshops_hosted: `3 Workshops veranstaltet`,
  number_energy_audits_completed: `4 Energieaudits abgeschlossen`,
  number_people_more_aware_of_climate_change_in_our_community: `200 Menschen in unserer Gemeinde sind sich des Klimawandels stärker bewusst`,
  number_new_playground_installed: `1 neuer Spielplatz installiert`,
  please_enter: `Bitte geben Sie`,
  which_of_the_company_impact_objectives_will_your_project_support: `Welche Wirkungsziele des Unternehmens wird Ihr Projekt unterstützen?`,
  what_outcomes_do_you_hope_your_project_will_achieve: `Welche Ergebnisse erhoffen Sie sich von Ihrem Projekt?`,
  what_is_an_outcome: `Was ist ein Ergebnis?`,
  an_outcome_is_the_change_you_hope_to_see_as_a_result_of_your_project_below_are_some_examples: `Ein Ergebnis ist die Veränderung, die Sie sich durch Ihr Projekt erhoffen. Nachfolgend finden Sie einige Beispiele.`,
  objective_protect_and_improve_the_local_environment: `Ziel: Schutz und Verbesserung der lokalen Umwelt`,
  outcome_improve_fish_populations_through_river_restoration: `Ergebnis: Verbesserung der Fischpopulationen durch Flussrenaturierung.`,
  objective_create_and_improve_local_amenities: `Ziel: Schaffung und Verbesserung lokaler Annehmlichkeiten`,
  outcome_improve_the_energy_efficiency_of_the_village_hall_with_new_windows: `Ergebnis: Verbesserung der Energieeffizienz des Gemeindehauses durch neue Fenster.`,
  objective_engage_the_local_community: `Ziel: Die lokale Gemeinschaft einbeziehen`,
  outcome_reduce_isolation_and_loneliness_in_older_people: `Ergebnis: Verringerung der Isolation und Einsamkeit bei älteren Menschen.`,
  how_will_you_achieve_these_outcomes: `Wie werden Sie diese Ergebnisse erreichen?`,
  briefly_describe_your_approach_to_achieving_the_outcomes: `Beschreiben Sie kurz Ihren Ansatz zum Erreichen der Ergebnisse.`,
  below_are_some_examples: `Nachfolgend finden Sie einige Beispiele:`,
  we_will_remove_excess_silt: `Wir entfernen überschüssigen Schlamm, sodass die Brutstätten der Fische wiederhergestellt werden.`,
  we_will_replace_our_old_windows_with_triple_glazed_windows: `Wir werden unsere alten Fenster durch dreifach verglaste Fenster ersetzen.`,
  we_will_run_weekly_workshops_bringing_older_people_together: `Wir werden wöchentliche Workshops veranstalten, die ältere Menschen zusammenbringen.`,
  how_will_you_achieve_this_outcome: `Wie werden Sie dieses Ergebnis erreichen?`,
  please_use_no_more_than_25_words_as_you_will_be_asked_to_describe_your_approach_on_the_next_screen: `Bitte verwenden Sie nicht mehr als 25 Wörter, da Sie auf dem nächsten Bildschirm aufgefordert werden, Ihren Ansatz zu beschreiben.`,
  enter_outcome: `Ergebnis eingeben`,
  please_enter_numeric_value: `Bitte geben Sie einen numerischen Wert ein`,
  expected_decision_date: `Voraussichtliches Entscheidungsdatum`,
  beneficiaries: `Begünstigte`,
  who_or_what_will_benefit_from_your_project: `Wer oder was profitiert von Ihrem Projekt?`,
  who_are_the_social_beneficiaries: `Wer sind die Sozialempfänger?`,
  select_beneficiary_type: `Begünstigtentyp auswählen`,
  how_many_people_will_benefit: `Wie viele Menschen werden davon profitieren?`,
  direct_beneficiaries: `Direktbegünstigte`,
  enter_estimated_number: `Geschätzte Zahl eingeben`,
  indirect_beneficiaries: `Indirekte Begünstigte`,
  how_will_the_environment_benefit: `Welchen Nutzen hat die Umwelt?`,
  for_example_species_of_new_plants_introduced_ppm_of_CO2_reduced_terrestrial_animals_protected: `Beispielsweise wurden 10 neue Pflanzenarten eingeführt, der CO2-Gehalt um 10 ppm gesenkt und 10 Landtiere geschützt.`,
  select_type_title: `Typ auswählen`,
  select_sub_type: `Untertyp auswählen`,
  select_units: `Einheiten auswählen`,
  your_environmental_beneficiaries_will_show_like_this_in_your_application_form: `Ihre Umweltbegünstigten werden in Ihrem Antragsformular wie folgt angezeigt:`,
  environmental_beneficiaries: `Umweltbegünstigte`,
  the_environmental_beneficiaries_drop_down_fields_enable_you_to_share_additional_details: `In den Dropdown-Feldern für Umweltbegünstigte können Sie zusätzliche Details angeben, z. B. ob Sie Arten, Lebensräume oder Gebäude, Pflanzen oder Tiere unterstützen und welche Maßnahmen Sie ergreifen.`,
  select_type_title_head: `Typ auswählen:`,
  choose_whether_your_project_supports_habitats_such_as_forests_or_woodlands: `Wählen Sie, ob Ihr Projekt Lebensräume wie Wälder oder Gehölze, Arten wie Pflanzen oder Tiere oder Gebäude wie Schulen oder gemeinsame Gemeinschaftsgebäude wie ein Gemeindehaus unterstützt.`,
  select_sub_type_head: `Untertyp auswählen:`,
  choose_the_type_of_habitat_species_or_building_you_are_supporting: `Wählen Sie den Lebensraumtyp, die Tierart oder das Gebäude, das Sie unterstützen möchten. Wählen Sie beispielsweise Süßwasser, wenn Sie Flüsse oder Seen unterstützen möchten.`,
  select_action_head: `Aktion auswählen:`,
  choose_the_type_of_action_you_re_taking_to_support_the_species: `Wählen Sie die Art der Aktion, mit der Sie die Art, den Lebensraum oder das Gebäude schützen möchten. Wählen Sie beispielsweise „geschützt“, wenn Sie gefährdete Arten schützen, oder „wiederhergestellt“, wenn Sie einen Lebensraum regenerieren möchten.`,
  enter_amount_head: `Geben Sie den Betrag ein:`,
  for_species_estimate_how_many_plants_or_animals_you_re_supporting_through_your_project: `Schätzen Sie bei den Arten, wie viele Pflanzen oder Tiere Sie durch Ihr Projekt unterstützen.`,
  for_habitats_estimate_how_many_habitats_you_re_supporting_number_or_the_total_area_in_hectares: `Schätzen Sie bei den Lebensräumen, wie viele Lebensräume Sie unterstützen (Anzahl) oder wie groß die Gesamtfläche (in Hektar) ist.`,
  for_buildings_estimate_how_many_buildings_you_re_supporting: `Schätzen Sie bei Gebäuden, wie viele Gebäude Sie unterstützen (Anzahl) oder um wie viel Sie Energie, Wasser oder Treibhausgase einsparen (Tonnen CO2-Äquivalente (CO2e)).`,
  select_units_head: `Einheiten auswählen:`,
  number_is_an_estimate_of_the_total_number_of_habitats_species_or_buildings_you_plan_to_support: `Die Zahl ist eine Schätzung der Gesamtzahl der Lebensräume, Arten oder Gebäude, die Sie unterstützen möchten.`,
  hectares_is_an_estimate_of_the_total_area_of_a_habitat_youre_supporting: `Hektar ist eine Schätzung der Gesamtfläche eines Lebensraums, den Sie unterstützen.`,
  social_beneficiaries: `Soziale Begünstigte`,
  select_the_type_of_beneficiaries_your_project_supports: `Wählen Sie die Art der Begünstigten aus, die Ihr Projekt unterstützt. Schätzen Sie anschließend die Gesamtzahl der Begünstigten, die Sie über alle Begünstigtentypen hinweg unterstützen möchten.`,
  direct_beneficiaries_head: `Direkte Begünstigte:`,
  the_number_of_people_who_directly_benefit_from_your_opportunity: `Die Anzahl der Personen, die direkt von Ihrer Gelegenheit profitieren.`,
  indirect_beneficiaries_head: `Indirekte Begünstigte:`,
  the_number_of_people_whose_benefits_can_be_attributed_to_a_direct_beneficiary: `Die Anzahl der Personen, deren Leistungen einem direkten Begünstigten zugerechnet werden können.`,
  for_example_if_your_project_supports_children_with_learning_disabilitie: `Wenn Ihr Projekt beispielsweise zehn Kinder mit Lernschwierigkeiten unterstützt, sind die zehn Kinder die direkten Begünstigten. Die indirekten Begünstigten sind die Familien dieser Kinder.`,
  habitats: `Lebensräume`,
  forest: `Wald`,
  deserts: `Wüste`,
  mountains: `Berg`,
  coastal: `Küsten`,
  marine: `Marine`,
  freshwater: `Süßwasser`,
  polar: `Polar`,
  wetlands: `Feuchtgebiete`,
  rainforest: `Regenwald`,
  arctic: `Arktis`,
  tundra: `Tundra`,
  restored: `Restauriert`,
  protected: `Geschützt`,
  created: `Erstellt`,
  hectares: `Hektar`,
  established: `Gegründet`,
  benefitted: `Begünstigt`,
  terrestrial_animals: `Landtiere`,
  aquatic_animals: `Wassertiere`,
  terrestrial_plants: `Landpflanzen`,
  aquatic_plants: `Wasserpflanzen`,
  species: `Spezies`,
  select_category: `Kategorie auswählen`,
  select_sub_category: `Unterkategorie auswählen`,
  please_add_at_least_one_outcome_under_selected_objectives: `Bitte fügen Sie mindestens 1 Ergebnis unter den ausgewählten Zielen hinzu`,
  please_enter_your_approach_for_each_outcome: `Bitte geben Sie für jedes Ergebnis Ihren Ansatz ein`,
  create_n_manage_sharing: `Freigaben erstellen und verwalten`,
  access_closing_date: `Zugangsschluss`,
  please_choose_closing_date: `Bitte wählen Sie das Schlussdatum`,
  newly_invited_users_will_receive_an_email_invitation: `Neu eingeladene Benutzer erhalten eine Einladung per E-Mail.`,
  existing_invited_users_will_not_be_notified_of_changes: `Bestehende eingeladene Benutzer werden nicht über Änderungen benachrichtigt.`,
  update: `Aktualisieren`,
  user_already_exists: `Benutzer existiert bereits`,
  verify_your_email: `Bestätigen Sie Ihre E-Mail`,
  please_verify_your_email_to_receive_a_magic_link: `Bitte bestätigen Sie Ihre E-Mail, um einen magischen Link für den Zugriff auf Ihr Feedback-Portal zu erhalten.`,
  emissions: `Emissionen`,
  greenhouse_gases: `Treibhausgase`,
  reduced: `Reduziert`,
  captured: `Gefangen`,
  prevented: `Verhindert`,
  tonnes_of_CO2_equivalents_C02e: `Tonnen CO2-Äquivalente (C02e)`,
  additional_questions: `Weitere Fragen`,
  required_documents: `Erforderliche Dokumente`,
  additional_files: `Weitere Dateien`,
  document_name: `Dokumentname`,
  custom_question: `Benutzerdefinierte Frage?`,
  custom_questions: `Benutzerdefinierte Fragen`,
  enter_answer: `Antwort eingeben`,
  if_you_are_awarded_support_you_may_be_required_to_share_interim_Updates: `Wenn Sie Unterstützung erhalten, müssen Sie möglicherweise Zwischenberichte und einen einmaligen Abschlussbericht an das Unternehmen weitergeben. Sie erhalten von BizGive eine E-Mail-Benachrichtigung, sobald diese fällig sind.`,
  can_you_meet_the_required_submission_deadlines: `Können Sie die geforderten Abgabetermine einhalten?`,
  based_on_the_estimated_start_and_finish_date_of_your_project: `Bitte bestätigen Sie anhand des voraussichtlichen Start- und Enddatums Ihres Projekts, dass Sie die unten aufgeführten Einreichungsfristen einhalten können. Sie können Ihre Projektdaten aktualisieren, sobald Ihre Bewerbung genehmigt ist.`,
  interim_updates: `Zwischenupdates`,
  final_report: `Abschlussbericht`,
  this_value_cannot_be_lower_than_the_amount_you_are_applying_for: `Dieser Wert darf nicht niedriger sein als der Betrag, den Sie beantragen`,
  what_is_an_interim_update: `Was ist ein Zwischenupdate?`,
  an_update_required_by_the_company_on_the_progress_of_your_project: `Ein vom Unternehmen benötigtes Update zum Fortschritt Ihres Projekts.`,
  download_interim_update_report_template: `Vorlage für den Zwischenaktualisierungsbericht herunterladen`,
  what_is_a_final_report: `Was ist ein Abschlussbericht`,
  a_single_report_required_by_the_company_on_what_your_project_achieved_with_the_support_provided: `Ein einziger vom Unternehmen geforderter Bericht darüber, was Ihr Projekt mit der bereitgestellten Unterstützung erreicht hat.`,
  download_final_report_template: `Vorlage für den Abschlussbericht herunterladen`,
  how_will_i_know_when_an_interim_update_or_final_report_is_due: `Wie erfahre ich, wann ein Zwischenupdate oder ein Abschlussbericht fällig ist?`,
  you_will_receive_an_email_notification_from_bizGive_when_the_deadline_is_approaching: `Sie erhalten eine E-Mail-Benachrichtigung von BizGive, wenn die Frist näher rückt. Folgen Sie den Anweisungen in diesen E-Mails, um die Berichte auszufüllen und an das Unternehmen zu senden.`,
  contact_details: `Kontaktdetails`,
  after_submitting_your_application_you_will_receive_email_notifications_from_BizGive_on_its_status: `Nachdem Sie Ihre Bewerbung abgeschickt haben, erhalten Sie von BizGive E-Mail-Benachrichtigungen über den Status.`,
  please_add_another_contact_in_case_of_your_absence: `Bitte geben Sie für den Fall Ihrer Abwesenheit einen weiteren Kontakt an.`,
  if_theyre_already_on_BizGive_select_their_name_below: `Wenn sie bereits bei BizGive sind, wählen Sie unten ihren Namen aus:`,
  invite_a_colleague_to_join_by_entering_their_email_address_below: `Laden Sie einen Kollegen zur Teilnahme ein, indem Sie unten seine E-Mail-Adresse eingeben:`,
  select_user: `Benutzer auswählen`,
  what_is_an_indicator: `Was ist ein Indikator?`,
  an_indicator_is_a_measure_of_progress: `Ein Indikator ist ein Maß für den Fortschritt. Er umfasst ein Ziel und Meilensteine ​​zur Erreichung dieses Ziels. Beispielsweise die Anzahl der Personen, denen Sie helfen möchten, und wie sich diese Zahl im Laufe der Zeit steigern wird.`,
  an_indicator_is_an_estimate: `Ein Indikator ist eine Schätzung. Machen Sie sich also keine Sorgen, wenn sich Ihre Pläne ändern. Wenn Ihr Antrag genehmigt wird, werden Sie gebeten, Ihre Indikatoren zu aktualisieren.`,
  indicator_examples: `Beispiele für Indikatoren`,
  no_of_people_gaining_a_new_skill_or_qualification: `Anzahl der Personen, die eine neue Fähigkeit oder Qualifikation erwerben`,
  no_of_workshops_hosted: `Anzahl der veranstalteten Workshops`,
  decrease_in_local_unemployment: `% Rückgang der lokalen Arbeitslosigkeit`,
  when_do_i_update_my_indicators: `Wann aktualisiere ich meine Indikatoren?`,
  if_your_application_is_approved: `Wenn Ihr Antrag genehmigt wird, erhalten Sie von BizGive E-Mail-Benachrichtigungen, wenn Sie Ihre Indikatoren aktualisieren müssen.`,
  how_often_do_I_update_my_indicators: `Wie oft aktualisiere ich meine Indikatoren?`,
  you_will_be_asked_to_update_your_indicators_at_the_same_time: `Sie werden gleichzeitig mit der Einreichung Ihres Zwischenupdates oder Abschlussberichts aufgefordert, Ihre Indikatoren zu aktualisieren.`,
  measuring_progress: `Fortschritt messen`,
  objective_outcome_specific_indicators: `Ziel-/ergebnisspezifische Indikatoren`,
  mandatory_title: `Obligatorisch`,
  about_your_project: `Über Ihr Projekt`,
  your_request: `Ihre Anfrage`,
  planned_impact_title: `Geplante Auswirkungen`,
  award_criteria: `Vergabekriterien`,
  step_1: `Schritt 1`,
  step_2: `Schritt 2`,
  step_3: `Schritt 3`,
  step_4: `Schritt 4`,
  step_5: `Schritt 5`,
  submit_your_application: `Senden Sie Ihre Bewerbung`,
  to_submit_your_application_you_must_read_and_agree_to_the_application: `Um Ihre Bewerbung einzureichen, müssen Sie die Bewerbungsunterlagen lesen und ihnen zustimmen.`,
  terms_and_conditions: `Geschäftsbedingungen`,
  below: `unten.`,
  please_note_you_will_not_be_able_to_edit_your_application_after_it_has_been_submitted_unless_requested_to_by_the_company_youre_applying_to: `Bitte beachten Sie, dass Sie Ihre Bewerbung nach dem Absenden nicht mehr bearbeiten können, es sei denn, das Unternehmen, bei dem Sie sich bewerben, fordert Sie dazu auf.`,
  by_submitting_this_application_you_will_be_sharing_your_application_user_details_and_ongoing_entity_profile_information_with_the_funder: `Durch das Absenden dieses Antrags geben Sie Ihren Antrag, Ihre Benutzerdetails und die aktuellen Unternehmensprofilinformationen an den Geldgeber weiter.`,
  enter_caption: `Beschriftung eingeben...`,
  impact_alignment: `Wirkungsausrichtung`,
  approve: `Genehmigen`,
  decline: `Abfall`,
  requested_support: `Angeforderter Support`,
  total_request: `Gesamtanfrage`,
  total_project_budget: `Gesamtes Projektbudget`,
  funder_contribution: `Fördererbeitrag`,
  planned_expenditure: `Geplante Ausgaben`,
  additional_funding: `Zusätzliche Finanzierung`,
  additional_funding_is_required_to_meet_the_total_opportunity_budget: `Um das Gesamtbudget für die Gelegenheit zu decken, sind zusätzliche Mittel erforderlich`,
  where_will_additional_funds_be_sourced: `Woher werden zusätzliche Mittel kommen?`,
  has_this_funding_been_secured: `Ist diese Finanzierung gesichert?`,
  can_this_project_go_ahead_without_additional_funding: `Kann dieses Projekt ohne zusätzliche Finanzierung durchgeführt werden?`,
  outputs: `Ausgänge`,
  you_must_select_yes_to_proceed: `Sie müssen „Ja“ auswählen, um fortzufahren`,
  please_enter_the_dates_within_the_above_mentioned_limits: `Bitte geben Sie die Daten innerhalb der oben genannten Grenzen ein`,
  at_least_one_checkbox_must_be_selected: `Mindestens ein Kontrollkästchen muss aktiviert sein`,
  delete_confirmation: `Löschbestätigung`,
  unchecking_this_box_will_delete_any_underlying_data_you_have_entered_for_this_objective_or_outcome: `Wenn Sie dieses Kontrollkästchen deaktivieren, werden alle zugrunde liegenden Daten gelöscht, die Sie für dieses Ziel oder Ergebnis eingegeben haben.`,
  at_least_one_outcome_must_be_selected: `Mindestens 1 Ergebnis muss ausgewählt werden`,
  please_select_at_least_one_objective: `Bitte wählen Sie mindestens 1 Ziel aus`,
  project_timelines: `Projektzeitpläne`,
  project_location: `Projektstandort`,
  pending_title: `Ausstehend`,
  view_indicator: `Anzeige anzeigen`,
  indicators_status_confirmation: `Anzeigenstatus Bestätigung`,
  indicators_successfully_submitted: `Indikatoren erfolgreich übermittelt`,
  please_create_at_least_indicator_outcome: `Bitte erstellen Sie mindestens einen Indikator pro Ergebnis`,
  please_complete_n_delete_pending_indicators: `Bitte ergänzen oder löschen Sie ausstehende Indikatoren`,
  modal_will_be_closed_after_two_seconds: `Das Modal wird nach zwei Sekunden geschlossen`,
  please_enter_indicatorInterimActual: `Bitte geben Sie den Indikator „ZwischenIst“ ein`,
  no_comments: `Keine Kommentare`,
  enter_final_total: `Endsumme eingeben`,
  milestone_date: `Meilensteindatum`,
  accumulative_target: `Kumulatives Ziel`,
  actuals: `Istwerte`,
  evidence: `Beweis`,
  total_target: `Gesamtziel`,
  please_enter_total_accumulative_target: `Bitte geben Sie das gesamte kumulative Ziel ein`,
  please_add_value_for_historic_milestone: `Bitte fügen Sie für jeden historischen Meilenstein einen Wert hinzu`,
  cancel_uppercase: `STORNIEREN`,
  submit_uppercase: `EINREICHEN`,
  press_submit_to_confirm: `Drücken Sie Senden, um Ihre Eingabe zu bestätigen. Beachten Sie, dass diese Informationen an`,
  confirmation: `Bestätigung`,
  your_donor_n_can_not_be_edited: `Ihr Spender und kann nicht bearbeitet werden`,
  indicator_name: `Indikatorname`,
  please_enter_indicator_name: `Bitte geben Sie den Indikatornamen ein`,
  main_focus: `Schwerpunkt`,
  social_n_beneficiaries: `Soziales / Begünstigte`,
  please_select_beneficiaries: `Bitte wählen Sie die Begünstigten aus`,
  please_enter_unit: `Bitte geben Sie die Einheit ein`,
  how_will_you_measure_progress: `Wie werden Sie den Fortschritt messen?`,
  starting_number_level_indicator: `Startnummer/Level Ihres Indikators`,
  if_you_do_not_know_this_then_enter_zero: `Wenn Sie dies nicht wissen, geben Sie 0 ein`,
  target_number_or_level_reach: `Zu erreichende Zielzahl oder Zielniveau`,
  target_we_aim_to_reach_is: `Das Ziel, das wir erreichen wollen, ist`,
  from_starting_number_n_level: `ab Startnummer/Level`,
  estimate_what_change_starting_para: `Optional: Schätzen Sie, wie sich die Startzahl/das Startniveau bis zum Ende Ihrer Opportunity-Zeitleiste ändern würde, wenn Sie nicht eingegriffen hätten?`,
  your_total_effort_will_be: `Ihr Gesamtaufwand wird`,
  taking_account_you_did_not_intervene: `unter Berücksichtigung dessen, was passieren würde, wenn Sie nicht eingreifen würden`,
  how_will_you_gather_evidence: `Wie werden Sie Beweise sammeln?`,
  please_enter_details: `Bitte geben Sie Details ein`,
  evidence_verification_method: `Methode zur Beweisüberprüfung`,
  your_contribution: `Ihr Beitrag`,
  measuring_your_impact: `Messen Sie Ihre Wirkung`,
  to_measure_the_progress_of_your_opportunity: `Um den Fortschritt Ihrer Chance zu messen, hat das Unternehmen Sie gebeten, Indikatoren hinzuzufügen. Mithilfe von Indikatoren können Sie geschätzte Ziele mit Meilensteinen für deren Erreichung festlegen.`,
  opportunity_indicators: `Chancenindikatoren`,
  these_indicators_are_general_to_your_opportunity_or_entity: `Diese Indikatoren gelten allgemein für Ihre Opportunity oder Ihr Unternehmen. Klicken Sie auf „Hinzufügen“, um sie zu erstellen.`,
  these_indicators_support_the_specific_objectives_and_outcomes: `Diese Indikatoren unterstützen die spezifischen Ziele und Ergebnisse Ihrer Chance. Klicken Sie auf „Hinzufügen“, um sie zu erstellen.`,
  describe_the_starting_situation: `Beschreiben Sie die Ausgangssituation:`,
  describe_the_final_situation: `Beschreiben Sie den gewünschten Ziel-Endzustand:`,
  describe_the_final_title_situation: `Beschreiben Sie die gewünschte Endsituation:`,
  please_confirm_that_you_can_provide_any_of_following_evidence_items: `Bitte bestätigen Sie, dass Sie folgende Nachweise erbringen können`,
  starting_number_level_of_your_indicator: `Startnummer Ihres Indikators`,
  target_number_or_level_to_reach: `Zu erreichende Zielzahl`,
  estimate_what_the_change_in_the_starting_number: `Optional: Schätzen Sie, wie sich die Startzahl/das Startniveau bis zum Ende Ihrer Opportunity-Zeitleiste ändern würde, wenn Sie nicht eingegriffen hätten?`,
  the_target_we_aim_to_reach_is_employed_from_the_starting_number_level: `Das Ziel, das wir erreichen wollen, ist die Anzahl der Beschäftigten ab der Startanzahl/-ebene`,
  your_total_impact_will_be_employed: `Ihre Gesamtwirkung beträgt:`,
  your_final_absolute_change_is_impactNumber: `Ihre endgültige absolute Änderung ist impactNumber`,
  your_final_relative_change_is_impactNumber: `Ihre endgültige relative Änderung ist impactNumber`,
  we_will_aim_for_sample_size_of_individuals: `Wir streben eine Stichprobengröße von 20 Personen an …`,
  restrict_applications_to_within_certain_radius_of_this_location: `Bewerbungen auf einen bestimmten Umkreis dieses Standorts beschränken?`,
  enter_number: `Nummer eingeben`,
  biannually: `Zweijährlich`,
  please_select_your_impact_strategy: `Bitte wählen Sie Ihre Impact-Strategie`,
  reporting_requirements: `Berichtspflichten`,
  starting: `Starten`,
  create_indicator: `Indikator erstellen`,
  optional_title: `Optional`,
  optional_head: `Optional?`,
  estimate_what_the_level_would_be: `Schätzen Sie, wie sich die Startzahl bis zum Enddatum Ihres Projekts ändern würde, wenn Sie nicht eingegriffen hätten? (Bitte fügen Sie ein +/- Zeichen hinzu)`,
  this_value_cannot_be_more_than_the_amount_you_are_applying_for: `Dieser Wert darf nicht höher sein als der von Ihnen beantragte Betrag`,
  you_must_apply_for_100_percentage_of_the_total_project_cost: `Sie müssen 100 % der gesamten Projektkosten beantragen`,
  please_save_a_location: `Bitte speichern Sie einen Standort`,
  i_agree: `Ich stimme zu`,
  project_running_dates: `Laufzeiten der Projekte`,
  donations_required_before: `Spenden erforderlich vor`,
  add_programme: `Programm hinzufügen`,
  budget_end_date: `Budget-Enddatum`,
  application_window: `Anwendungsfenster`,
  choose_either_option: `Wählen Sie eine der folgenden Optionen:`,
  copy_an_existing_programme: `Vorhandenes Programm kopieren`,
  create_a_new_programme: `Neues Programm erstellen`,
  what_is_the_name_of_your_programme: `Wie heißt Ihr Programm?`,
  what_is_the_area_of_impact: `Was ist der Aufprallbereich?`,
  projects_or_impact_must_be_within: `Projekte oder Auswirkungen müssen innerhalb von liegen:`,
  a_custom_area: `Ein benutzerdefinierter Bereich`,
  an_administrative_boundary_eg_a_council_area_or_country: `Eine Verwaltungsgrenze, z. B. ein Gemeindegebiet oder Land.`,
  a_certain_distance_from_a_point: `Eine bestimmte Entfernung von einem Punkt.`,
  click_on_the_map_to_start_drawing_your_area: `Klicken Sie auf die Karte, um mit dem Zeichnen Ihres Gebiets zu beginnen. Doppelklicken Sie, um es fertigzustellen. Bei Bedarf können Sie es aus der Option „Gebietsname“ unter der Karte löschen, indem Sie auf das Löschsymbol rechts neben dem`,
  use_the_search_box_to_find_administrative_boundaries: `Nutzen Sie das Suchfeld, um Verwaltungsgrenzen zu finden. Klicken Sie auf den Namen einer Grenze, um diese anzuzeigen. Wählen Sie eine Grenze mit „Auswählen“ aus. Löschen oder bearbeiten Sie Gebiete im Bereich „Gebietsnamen“ unter dem`,
  click_on_the_map_to_add_a_point: `Klicken Sie auf die Karte, um einen Punkt hinzuzufügen. Geben Sie anschließend unten einen zulässigen Radius ein und klicken Sie auf „Bereich erstellen“, um den Bereich auf der Karte anzuzeigen. Klicken Sie erneut auf die Karte, um einen neuen Punkt hinzuzufügen.`,
  what_is_the_area_called: `Wie heißt das Gebiet?`,
  programme_details: `Programmdetails`,
  write_a_short_summary_of_your_programme: `Schreiben Sie eine kurze Zusammenfassung Ihres Programms`,
  write_a_longer_description: `Schreiben Sie eine längere Beschreibung`,
  do_you_wish_to_share_any_supporting_material: `Möchten Sie unterstützendes Material weitergeben?`,
  select_all_options: `Alle Optionen auswählen`,
  indicators: `Indikatoren`,
  details: `Details`,
  programme_support: `Programmunterstützung`,
  what_support_can_you_offer: `Welche Unterstützung können Sie anbieten?`,
  what_is_your_budget: `Wie hoch ist Ihr Budget`,
  make_this_budget_amount_visible_in_your_programme_as_an_estimated_budget: `Machen Sie diesen Budgetbetrag in Ihrem Programm als „Geschätztes Budget“ sichtbar.`,
  is_there_a_limit_donation_amount_per_project: `Gibt es eine Spendenhöchstgrenze pro Projekt?`,
  projects_must_be_fully_funded_by_you_without_additional_third_party_funding: `Projekte müssen vollständig von Ihnen finanziert werden, ohne zusätzliche Drittmittel`,
  does_this_budget_recur: `Wird dieses Budget wiederkehren?`,
  per_project: `Pro Projekt`,
  no_it_is_fixed: `Nein, es ist behoben.`,
  yes_annual_starting_on: `Ja, jährlich ab:`,
  please_include_in_your_invoice_the_following_details: `Bitte geben Sie in Ihrer Rechnung die folgenden Details an ...`,
  share_any_invoice_instructions_for_approved_grantees_to_view: `Geben Sie alle Rechnungsanweisungen an genehmigte Empfänger weiter, damit diese sie einsehen können.`,
  do_you_want_to_upload_an_invoice_template_for_approved_applicants_to_use: `Möchten Sie eine Rechnungsvorlage hochladen, die von zugelassenen Antragstellern verwendet werden kann?`,
  what_type_of_volunteering_can_you_offer: `Welche Art von Freiwilligenarbeit können Sie anbieten?`,
  what_skilled_volunteering_is_available: `Welche qualifizierte Freiwilligentätigkeit gibt es?`,
  start_date: `Startdatum`,
  end_date: `Enddatum`,
  general: `Allgemein`,
  skilled: `Erfahren`,
  skill: `Fähigkeit`,
  number_of_item_service: `Nummer (des Artikels/der Dienstleistung)`,
  item_service_description: `Artikel-/Leistungsbeschreibung`,
  what_type_of_in_kind_support_can_you_offer: `Welche Art von Sachleistungen können Sie anbieten?`,
  timelines: `Zeitleisten`,
  when_are_you_accepting_applications: `Wann nehmen Sie Bewerbungen entgegen?`,
  a_date_range: `Ein Datumsbereich`,
  ongoing: `Laufend`,
  when_are_application_decisions_made: `Wann wird über die Bewerbungen entschieden?`,
  periodically: `Periodisch`,
  when_do_you_expect_to_make_donations: `Wann rechnen Sie mit Spenden?`,
  do_you_want_to_restrict_project_timelines: `Möchten Sie Projektzeitpläne einschränken?`,
  projects_must_start_within: `Projekte müssen innerhalb von`,
  projects_must_not_be_longer_than: `Projekte dürfen nicht länger sein als`,
  months: `Monate`,
  eligible_entities: `Berechtigte Einrichtungen`,
  what_type_of_entity_is_able_to_apply_to_your_programme: `Welche Art von Einrichtung kann sich für Ihr Programm bewerben?`,
  please_select_all_that_apply_below: `Bitte wählen Sie unten alle zutreffenden Optionen aus.`,
  uk: `Vereinigtes Königreich`,
  international: `Internationales`,
  applicants_must_agree_to_these_before_applying: `Bewerber müssen diesen vor der Bewerbung zustimmen`,
  entity_project_must_be: `Entität/Projekt muss sein...`,
  application_questions: `Fragen zur Bewerbung`,
  do_you_want_to_add_any_custom_application_questions: `Möchten Sie benutzerdefinierte Anwendungsfragen hinzufügen?`,
  word_limit: `Wortbegrenzung`,
  question: `Frage`,
  achieved_impact_title: `Erzielte Wirkung`,
  this_application_has_been_edited: `Diese Anwendung wurde bearbeitet`,
  please_enter_your_application_terms_and_conditions: `Bitte geben Sie Ihre Bewerbungsbedingungen ein`,
  we_ask_all_applicants_to_approve_this_before_submitting_their_application: `Wir bitten alle Bewerber, diesem vor der Einreichung ihrer Bewerbung zuzustimmen.`,
  please_enter_a_link_to_your_privacy_policy: `Bitte geben Sie einen Link zu Ihrer Datenschutzrichtlinie ein`,
  we_ask_all_applicants_to_acknowledge_this_before_submitting_their_application: `Wir bitten alle Bewerber, dies vor dem Absenden ihrer Bewerbung zur Kenntnis zu nehmen.`,
  measuring_impact: `Wirkung messen`,
  when_do_you_want_to_receive_interim_updates: `Wann möchten Sie „Zwischenupdates“ erhalten?`,
  recurring_to_project_dates: `Wiederkehrend zu Projektterminen`,
  not_required: `Nicht erforderlich`,
  every: `Jeder`,
  days_between_project_start_and_end_dates: `Tage zwischen Projektstart- und -enddatum`,
  when_do_you_want_to_receive_a_final_report: `Wann möchten Sie einen Abschlussbericht erhalten?`,
  relative_to_project_dates: `Relativ zu Projektdaten`,
  days_after_the_project_end_date: `Tage nach dem Projektenddatum`,
  are_there_any_additional_questions_you_would_like_to_ask_in_the_final_report: `Gibt es noch weitere Fragen, die Sie im Abschlussbericht stellen möchten?`,
  do_you_want_additional_legal_terms_for_entities_to_accept_on_submission_of_reports_to_you: `Möchten Sie, dass Unternehmen bei der Übermittlung von Berichten an Sie zusätzliche rechtliche Bedingungen akzeptieren?`,
  programme_administration: `Programmverwaltung`,
  internal_approval_steps: `Interne Genehmigungsschritte`,
  approval_step: `Genehmigungsschritt`,
  voting: `Wählen`,
  scoring_category: `Bewertungskategorie`,
  create_the_categories_that_you_would_like_to_evaluate_applications_against: `Erstellen Sie die Kategorien, anhand derer Sie die Bewerbungen bewerten möchten, z. B. „Preis-Leistungs-Verhältnis“ oder „Gesamtwirkung“.`,
  insert: `Einfügen`,
  scoring_category_options: `Bewertungskategorieoptionen`,
  detail_the_category_options_available_to_be_selected_for_the_above_categories: `Geben Sie die verfügbaren Kategorienoptionen für die oben genannten Kategorien mit dem numerischen Wert jeder Option an, damit eine endgültige Punktzahl berechnet werden kann. Optional können Sie auch eine Beschreibung hinzufügen.`,
  list_the_scoring_category_options_with_a_value_and_an_optional_description: `Listen Sie die Bewertungskategorien mit einem Wert und einer optionalen Beschreibung auf. Beispielsweise könnte der Wert „1“ und die Beschreibung „Niedrig“ oder der Wert „3“ und die Beschreibung „Hoch“ sein.`,
  numerical_value: `Numerischer Wert`,
  optional_description: `Optionale Beschreibung`,
  who_will_manage_this_programme: `Wer wird dieses Programm verwalten?`,
  managers_can_edit_the_programme_interact_with_applicants_approve_applications_and_receive_related_email_notifications: `Manager können das Programm bearbeiten, mit Bewerbern interagieren, Bewerbungen genehmigen und entsprechende E-Mail-Benachrichtigungen erhalten.`,
  who_can_view_this_programme: `Wer kann dieses Programm sehen?`,
  viewers_can_view_the_programme_and_applications_but_not_edit_the_programme: `Zuschauer können das Programm und die Bewerbungen ansehen, aber nicht das Programm bearbeiten, mit Bewerbern interagieren, Bewerbungen genehmigen oder entsprechende E-Mail-Benachrichtigungen erhalten.`,
  programme_visibility: `Programmsichtbarkeit`,
  bizGive_open: `BizGive (offen)`,
  any_charity_signed_up_to_bizGive_can_view_and_apply_to_your_programme: `Jede bei BizGive registrierte Wohltätigkeitsorganisation kann Ihr Programm einsehen und sich dafür bewerben.`,
  bizGive_invite_only: `BizGive (nur auf Einladung)`,
  only_charities_you_invite_to_apply_to_your_programme_can_view_it: `Nur Wohltätigkeitsorganisationen, die Sie zur Bewerbung für Ihr Programm einladen, können es einsehen.`,
  public_open: `Öffentlich (Offen)`,
  your_programme_will_have_its_own_link_and_branded_landing_page_on_bizGive: `Ihr Programm erhält einen eigenen Link und eine eigene Landingpage auf BizGive, sodass Sie es auch außerhalb der Plattform teilen können. Jede bei BizGive registrierte Wohltätigkeitsorganisation kann das Programm einsehen und sich bewerben.`,
  public_invite_only: `Öffentlich (nur auf Einladung)`,
  your_programme_will_have_its_own_link_and_branded_landing_page_on_bizGive_invite_them_to_apply: `Ihr Programm erhält einen eigenen Link und eine eigene Landingpage auf BizGive, sodass Sie es auch außerhalb der Plattform teilen können. Es ist für die bei BizGive registrierten Wohltätigkeitsorganisationen nicht sichtbar, es sei denn, Sie`,
  add_a_custom_programme_url: `Hinzufügen einer benutzerdefinierten Programm-URL`,
  publish_your_programme: `Veröffentlichen Sie Ihr Programm`,
  this_will_make_your_programme_visible_as_per_your_visibility_settings: `Dadurch wird Ihr Programm gemäß Ihren Sichtbarkeitseinstellungen sichtbar.`,
  you_can_still_edit_all_details_of_the_programmes_after_publishing: `Sie können alle Details der Sendungen auch nach der Veröffentlichung noch bearbeiten.`,
  required_document_name: `Erforderlicher Dokumentname`,
  change: `Ändern`,
  number_of_days: `Anzahl der Tage`,
  programme_approval: `Programmgenehmigung`,
  there_must_be_at_least_1_votingScoreCriteria_added: `Es muss mindestens 1 Abstimmungsscorekriterium hinzugefügt werden`,
  there_must_be_at_least_1_votingCriteriaOptions_added: `Es muss mindestens 1 Abstimmungskriterienoption hinzugefügt werden`,
  publish: `Veröffentlichen`,
  confirm: `Bestätigen`,
  project_timeline: `Projektzeitplan`,
  company: `Unternehmen`,
  this_programme_is_closing_in_number_days: `Dieses Programm endet in Anzahl Tagen`,
  this_programme_is_now_closed: `Dieses Programm ist jetzt geschlossen`,
  the_application_window_is: `Das Anwendungsfenster ist`,
  login_or_signup_into_bizGive_to_discover_new_funding_programmes: `Melden Sie sich bei BizGive an oder registrieren Sie sich, um neue Finanzierungsprogramme zu entdecken.`,
  discover_more_programmes: `Entdecken Sie weitere Programme`,
  end: `Ende`,
  to_apply_to_the: `Zur Bewerbung an die`,
  log_in_or_sign_up_to_create_your_free_bizGive_account: `Melden Sie sich an oder registrieren Sie sich, um Ihr kostenloses BizGive-Konto zu erstellen.`,
  if_youre_new_to_BizGive_create_an_organisation_profile: `Wenn Sie neu bei BizGive sind, erstellen Sie ein Organisationsprofil.`,
  complete_your_application_to_the_programme: `Vervollständigen Sie Ihre Bewerbung für das Programm.`,
  receive_alerts_when_action_is_required_or_a_funding_decision_is_made: `Erhalten Sie Benachrichtigungen, wenn Maßnahmen erforderlich sind oder eine Finanzierungsentscheidung getroffen wird.`,
  apply_to_other_programmes_from_the_discover_section: `Bewerben Sie sich für andere Programme im Abschnitt „Entdecken“.`,
  entity_location: `Standort der Entität`,
  which_country_must_entities_be_located_in_leave_blank_if_any_are_accepted: `In welchem ​​Land müssen die Unternehmen ihren Sitz haben? Lassen Sie das Feld leer, wenn alle Länder akzeptiert werden.`,
  search_country: `Suche Land`,
  please_select_country: `Bitte wählen Sie ein Land`,
  your_requested_amount_exceeds_the_programme_limit: `Ihr angeforderter Betrag überschreitet das Programmlimit`,
  your_requested_amount_is_lower_than_the_programme_limit: `Ihr angeforderter Betrag liegt unter dem Programmlimit`,
  your_requested_amount_does_not_equal_the_programme_limit: `Ihr angeforderter Betrag entspricht nicht dem Programmlimit`,
  impact_across_multiple_programmes: `Auswirkungen auf mehrere Programme`,
  isLocal: `Ist lokal`,
  submission_date: `Einreichungsdatum:`,
  engagements: `Engagements`,
  dispersed_amount: `Verteilte Menge`,
  resource_used: `Verwendete Ressource`,
  approved_projects: `Genehmigte Projekte`,
  themes_support: `Unterstützte Themen`,
  themes: `Themen`,
  local_within_km: `Lokal im Umkreis von km`,
  group_by_visitor: `Nach Besucher gruppieren`,
  local_only: `Nur lokal`,
  within_km: `Innerhalb von Wert km`,
  maximum_grant_size: `Maximale Zuschusshöhe`,
  minimum_grant_size: `Mindestzuschusshöhe`,
  none_required: `Keine erforderlich`,
  outcome_title: `Ergebnis:`,
  consolidated_report: `Konsolidierter Bericht`,
  portfolio: `Portfolio`,
  portfolio_name: `Portfolioname`,
  period: `Zeitraum`,
  grant_size: `Zuschussgröße`,
  afghanistan: `Afghanistan`,
  albania: `Albanien`,
  algeria: `Algerien`,
  andorra: `Andorra`,
  angola: `Angola`,
  antigua_and_barbuda: `Antigua und Barbuda`,
  argentina: `Argentinien`,
  armenia: `Armenien`,
  australia: `Australien`,
  austria: `Österreich`,
  azerbaijan: `Aserbaidschan`,
  bahrain: `Bahrain`,
  bangladesh: `Bangladesch`,
  barbados: `Barbados`,
  belarus: `Weißrussland`,
  belgium: `Belgien`,
  belize: `Belize`,
  benin: `Benin`,
  bhutan: `Bhutan`,
  bolivia: `Bolivien`,
  bosnia_and_herzegovina: `Bosnien und Herzegowina`,
  botswana: `Botswana`,
  brazil: `Brasilien`,
  brunei: `Brunei`,
  bulgaria: `Bulgarien`,
  burkina_faso: `Burkina Faso`,
  burundi: `Burundi`,
  cambodia: `Kambodscha`,
  cameroon: `Kamerun`,
  canada: `Kanada`,
  cape_verde: `Kap Verde`,
  central_african_republic: `Zentralafrikanische Republik`,
  chad: `Tschad`,
  chile: `Chile`,
  china: `China`,
  colombia: `Kolumbien`,
  comoros: `Komoren`,
  congo: `Kongo`,
  congo_democratic_republic: `Kongo (Demokratische Republik)`,
  costa_rica: `Costa Rica`,
  croatia: `Kroatien`,
  cuba: `Kuba`,
  cyprus: `Zypern`,
  czechia: `Tschechien`,
  denmark: `Dänemark`,
  djibouti: `Dschibuti`,
  dominica: `Dominica`,
  dominican_republic: `Dominikanische Republik`,
  east_timor: `Osttimor`,
  ecuador: `Ecuador`,
  egypt: `Ägypten`,
  el_salvador: `El Salvador`,
  equatorial_guinea: `Äquatorialguinea`,
  eritrea: `Eritrea`,
  estonia: `Estland`,
  eswatini: `Eswatini`,
  ethiopia: `Äthiopien`,
  fiji: `Fidschi`,
  finland: `Finnland`,
  france: `Frankreich`,
  gabon: `Gabun`,
  georgia: `Georgia`,
  germany: `Deutschland`,
  ghana: `Ghana`,
  greece: `Griechenland`,
  grenada: `Grenada`,
  guatemala: `Guatemala`,
  guinea: `Guinea`,
  guinea_bissau: `Guinea-Bissau`,
  guyana: `Guyana`,
  haiti: `Haiti`,
  honduras: `Honduras`,
  hungary: `Ungarn`,
  iceland: `Island`,
  india: `Indien`,
  indonesia: `Indonesien`,
  iran: `Iran`,
  iraq: `Irak`,
  ireland: `Irland`,
  israel: `Israel`,
  italy: `Italien`,
  ivory_coast: `Elfenbeinküste`,
  jamaica: `Jamaika`,
  japan: `Japan`,
  jordan: `Jordanien`,
  kazakhstan: `Kasachstan`,
  kenya: `Kenia`,
  kiribati: `Kiribati`,
  kosovo: `Kosovo`,
  kuwait: `Kuwait`,
  kyrgyzstan: `Kirgisistan`,
  laos: `Laos`,
  latvia: `Lettland`,
  lebanon: `Libanon`,
  lesotho: `Lesotho`,
  liberia: `Liberia`,
  libya: `Libyen`,
  liechtenstein: `Liechtenstein`,
  lithuania: `Litauen`,
  luxembourg: `Luxemburg`,
  madagascar: `Madagaskar`,
  malawi: `Malawi`,
  malaysia: `Malaysia`,
  maldives: `Malediven`,
  mali: `Mali`,
  malta: `Malta`,
  marshall_islands: `Marshallinseln`,
  mauritania: `Mauretanien`,
  mauritius: `Mauritius`,
  mexico: `Mexiko`,
  federated_states_of_micronesia: `Föderierte Staaten von Mikronesien`,
  moldova: `Moldawien`,
  monaco: `Monaco`,
  mongolia: `Mongolei`,
  montenegro: `Montenegro`,
  morocco: `Marokko`,
  mozambique: `Mosambik`,
  myanmar_burma: `Myanmar (Burma)`,
  namibia: `Namibia`,
  nauru: `Nauru`,
  nepal: `Nepal`,
  netherlands: `Niederlande`,
  new_zealand: `Neuseeland`,
  nicaragua: `Nicaragua`,
  niger: `Niger`,
  nigeria: `Nigeria`,
  north_korea: `Nordkorea`,
  north_macedonia: `Nordmazedonien`,
  norway: `Norwegen`,
  oman: `Oman`,
  pakistan: `Pakistan`,
  palau: `Palau`,
  panama: `Panama`,
  papua_new_guinea: `Papua-Neuguinea`,
  paraguay: `Paraguay`,
  peru: `Peru`,
  philippines: `Philippinen`,
  poland: `Polen`,
  portugal: `Portugal`,
  qatar: `Katar`,
  romania: `Rumänien`,
  russia: `Russland`,
  rwanda: `Ruanda`,
  st_kitts_and_nevis: `St. Kitts und Nevis`,
  st_lucia: `St. Lucia`,
  st_vincent: `St. Vincent`,
  samoa: `Samoa`,
  san_marino: `San Marino`,
  sao_tome_and_principe: `São Tomé und Príncipe`,
  saudi_arabia: `Saudi-Arabien`,
  senegal: `Senegal`,
  serbia: `Serbien`,
  seychelles: `Seychellen`,
  sierra_leone: `Sierra Leone`,
  singapore: `Singapur`,
  slovakia: `Slowakei`,
  slovenia: `Slowenien`,
  solomon_islands: `Salomonen`,
  somalia: `Somalia`,
  south_africa: `Südafrika`,
  south_korea: `Südkorea`,
  south_sudan: `Südsudan`,
  spain: `Spanien`,
  sri_lanka: `Sri Lanka`,
  sudan: `Sudan`,
  suriname: `Suriname`,
  sweden: `Schweden`,
  switzerland: `Schweiz`,
  syria: `Syrien`,
  tajikistan: `Tadschikistan`,
  tanzania: `Tansania`,
  thailand: `Thailand`,
  the_bahamas: `Die Bahamas`,
  the_gambia: `Gambia`,
  togo: `Togo`,
  tonga: `Tonga`,
  trinidad_and_tobago: `Trinidad und Tobago`,
  tunisia: `Tunesien`,
  turkey: `Truthahn`,
  turkmenistan: `Turkmenistan`,
  tuvalu: `Tuvalu`,
  uganda: `Uganda`,
  ukraine: `Ukraine`,
  united_arab_emirates: `Vereinigte Arabische Emirate`,
  united_kingdom: `Vereinigtes Königreich`,
  united_states: `Vereinigte Staaten`,
  uruguay: `Uruguay`,
  uzbekistan: `Usbekistan`,
  vanuatu: `Vanuatu`,
  vatican_city: `Vatikanstadt`,
  venezuela: `Venezuela`,
  vietnam: `Vietnam`,
  yemen: `Jemen`,
  zambia: `Sambia`,
  zimbabwe: `Simbabwe`,
  already_registered: `Bereits registriert?`,
  login_here: `Hier anmelden`,
  application_to: `Bewerbung an`,
  continue_application: `Bewerbung fortsetzen`,
  delete_application: `Anwendung löschen`,
  edit_resubmit: `Bearbeiten und erneut übermitteln`,
  withdraw: `Zurückziehen`,
  final_reports: `Abschlussberichte`,
  this_will_withdraw_your_application_and_return_it_to_a_pending_state: `Dadurch wird Ihre Bewerbung zurückgezogen und in den Status „Ausstehend“ zurückversetzt.`,
  this_will_delete_your_application_and_saved_data: `Dadurch werden Ihre Bewerbung und die gespeicherten Daten gelöscht.`,
  withdraw_application: `Antrag zurückziehen`,
  send: `Schicken`,
  enable_editing_of_application: `Bearbeiten der Anwendung aktivieren`,
  application_editing_enabled: `Anwendungsbearbeitung aktiviert`,
  pre_approve: `Vorab genehmigen`,
  withdraw_pre_approval: `Vorabgenehmigung zurückziehen`,
  confirm_approval: `Genehmigung bestätigen`,
  grant_award: `Zuschuss`,
  please_confirm_you_wish_to_approve_this_application: `Bitte bestätigen Sie, dass Sie diesen Antrag genehmigen möchten.`,
  share_a_message: `Teilen Sie eine Nachricht:`,
  confirm_decline: `Ablehnung bestätigen`,
  please_explain_your_decision_to_the_applicant: `Bitte begründen Sie Ihre Entscheidung gegenüber dem Bewerber`,
  application_related: `Anwendungsbezogen`,
  entity_related: `Entitätsbezogen`,
  programme_related: `Programmbezogen`,
  add_a_message: `Nachricht hinzufügen`,
  there_are_items_we_cannot_fund: `Es gibt Artikel, die wir nicht finanzieren können`,
  the_impact_of_your_project_is_not_clear_enough: `Die Auswirkungen Ihres Projekts sind nicht klar genug`,
  the_impact_of_your_project_is_lower_relative_to_other_applications: `Die Wirkung Ihres Projekts ist im Vergleich zu anderen Anwendungen geringer.`,
  your_entity_does_not_meet_our_criteria: `Ihr Unternehmen erfüllt nicht unsere Kriterien`,
  your_project_does_not_align_closely_enough_with_our_objectives: `Ihr Projekt deckt sich nicht ausreichend mit unseren Zielen`,
  other_projects_more_closely_aligned_with_our_objectives: `Andere Projekte, die besser auf unsere Ziele abgestimmt sind`,
  your_project_did_not_fully_meet_our_eligibility_criteria: `Ihr Projekt hat unsere Förderkriterien nicht vollständig erfüllt`,
  funding_in_this_round_has_already_been_disbursed_to_similar_projects: `Die Mittel dieser Runde wurden bereits an ähnliche Projekte ausgezahlt`,
  please_select_an_decline_option_or_write_a_message: `Bitte wählen Sie eine Ablehnungsoption oder schreiben Sie eine Nachricht`,
  confirm_pre_approval: `Vorabgenehmigung bestätigen`,
  please_confirm_your_pre_approval: `Bitte bestätigen Sie Ihre Vorabgenehmigung.`,
  please_confirm_your_approval: `Bitte bestätigen Sie Ihre Zustimmung.`,
  pre_approving_will_not_notify_the_applicant: `Bei einer Vorabgenehmigung erfolgt keine Benachrichtigung des Antragstellers.`,
  approving_will_not_notify_the_applicant: `Der Antragsteller wird bei der Genehmigung nicht benachrichtigt.`,
  internal_review: `Interne Überprüfung`,
  entity_history: `Entitätsverlauf`,
  you_have_received_an_application_from_this_entity_before: `Sie haben bereits eine Bewerbung von dieser Stelle erhalten.`,
  approval: `Genehmigung`,
  approved_by: `Genehmigt von`,
  confirm_step_completion: `Schrittabschluss bestätigen`,
  please_confirm_this_step_has_been_completed: `Bitte bestätigen Sie, dass dieser Schritt abgeschlossen wurde.`,
  total_score: `Gesamtpunktzahl`,
  voters: `Wähler`,
  category_totals: `Kategoriesummen`,
  name: `Name`,
  telephone: `Telefon`,
  email: `E-Mail`,
  category_score: `Kategoriebewertung`,
  date: `Datum`,
  my_vote: `Meine Stimme`,
  saved: `Gespeichert`,
  vote: `Abstimmung`,
  value_for_money: `Preis-Leistungs-Verhältnis`,
  total_impact: `Gesamtwirkung`,
  total: `Gesamt`,
  comments: `Kommentare`,
  edit: `Bearbeiten`,
  what_are_your_overall_comments: `Was sind Ihre allgemeinen Kommentare?`,
  select_score: `Wählen Sie Partitur`,
  please_select_at_least_one_checkbox: `Bitte wählen Sie mindestens ein Kontrollkästchen aus`,
  create_your_profile: `Erstellen Sie Ihr Profil`,
  on_the_following_screens_you_will_be_asked_to_complete_a_profile_of_your_entity: `Auf den folgenden Bildschirmen werden Sie aufgefordert, ein Profil Ihres Unternehmens auszufüllen.`,
  how_your_profile_is_used: `Wie Ihr Profil verwendet wird`,
  once_your_profile_is_complete_it_will_be_automatically_attached_to_any_application_you_submit_through_bizGive: `Sobald Ihr Profil vollständig ist, wird es automatisch an jede Bewerbung angehängt, die Sie über BizGive einreichen.`,
  companies_and_bizGive_use_your_profile_to_perform_background_due_diligence_checks_on_your_organisation_it_is_only_visible_to_companies_you_apply_to: `Unternehmen und BizGive nutzen Ihr Profil, um Hintergrundprüfungen Ihrer Organisation durchzuführen. Es ist nur für Unternehmen sichtbar, bei denen Sie sich bewerben.`,
  once_complete_you_will_be_able_to_apply_to_as_many_company_programmes_as_you_re_eligible_for_from_the_discover_tab: `Sobald Sie fertig sind, können Sie sich über die Registerkarte „Entdecken“ für so viele Unternehmensprogramme bewerben, wie Sie für zulässig erachten.`,
  profile_guidance: `Profilberatung`,
  saves_your_data_and_moves_you_to_the_next_screen_your_answers_will_automatically_be_saved_unless_you_have_an_internet_connectivity_issue: `speichert Ihre Daten und führt Sie zum nächsten Bildschirm. Ihre Antworten werden automatisch gespeichert, sofern Sie kein Problem mit der Internetverbindung haben.`,
  saves_your_data_and_logs_you_out_of_bizGive: `speichert Ihre Daten und meldet Sie von BizGive ab. Sie können Ihr Profil fortsetzen, wenn Sie sich erneut anmelden. Sie müssen alle erforderlichen Felder ausfüllen, um „Speichern & Beenden“ zu wählen (Sie können beliebige Werte eingeben).`,
  entity_details: `Entitätsdetails`,
  name_n_address: `Name und Adresse`,
  do_you_have_a_different_trading_name_or_display_name: `Haben Sie einen anderen Handelsnamen oder Anzeigenamen?`,
  legal_structure: `Rechtsform`,
  what_is_your_legal_structure: `Wie ist Ihre Rechtsform?`,
  unregistered_organisation: `Nicht registrierte Organisation`,
  what_is_your_registration_number: `Wie lautet Ihre Registrierungsnummer?`,
  this_is_your_registration_number_with_the_relevant_regulator_of_your_entity: `Dies ist Ihre Registrierungsnummer bei der zuständigen Aufsichtsbehörde Ihres Unternehmens.`,
  please_share_a_link_to_your_online_registration: `Bitte teilen Sie einen Link zu Ihrer Online-Registrierung`,
  this_is_a_link_to_your_profile_on_the_regulators_website: `Dies ist ein Link zu Ihrem Profil auf der Website der Regulierungsbehörde.`,
  please_upload_a_copy_of_your_governing_document: `Bitte laden Sie eine Kopie Ihrer Verwaltungsdokumente hoch`,
  these_are_not_available: `Diese sind nicht verfügbar`,
  please_share_a_reason: `Bitte teilen Sie einen Grund mit`,
  please_upload_a_copy_of_your_governing_documents: `Bitte laden Sie eine Kopie Ihrer Verwaltungsdokumente hoch`,
  for_example_your_trust_deed: `Zum Beispiel Ihre Treuhandurkunde.`,
  please_upload_a_copy_of_your_most_recent_annual_accounts: `Bitte laden Sie eine Kopie Ihres letzten Jahresabschlusses hoch`,
  for_example_your_Articles_of_association: `Zum Beispiel Ihre Satzung.`,
  please_upload_a_copy_of_your_constitution_trust_deed_or_rules: `Bitte laden Sie eine Kopie Ihrer Satzung, Treuhandurkunde oder Regeln hoch`,
  please_upload_a_copy_of_your_registration_documents_or_most_recent_annual_accounts: `Bitte laden Sie eine Kopie Ihrer Registrierungsunterlagen oder Ihres letzten Jahresabschlusses hoch`,
  entity_types: `Entitätstypen`,
  registered_with_the_relevant_national_or_regional_regulatory_authority_for_example_the_charity_commission_in_the_uk: `Registriert bei der zuständigen nationalen oder regionalen Regulierungsbehörde. Beispielsweise bei der Charity Commission im Vereinigten Königreich.`,
  community_interest_company_uk_only: `Community Interest Company (nur Großbritannien)`,
  registered_with_companies_house: `Registriert beim Companies House. Eine besondere Form einer gemeinnützigen Gesellschaft mit beschränkter Haftung, die zum Wohle der Gemeinschaft oder zur Verfolgung sozialer Zwecke gegründet wurde. Viele Sozialunternehmen sind CICs.`,
  a_type_of_charity_run_by_a_small_group_of_people_known_as_trustees: `Eine Wohltätigkeitsorganisation, die von einer kleinen Gruppe von Personen, den sogenannten Treuhändern, geführt wird. In Großbritannien muss sich ein Trust bei der Charity Commission registrieren lassen, wenn sein Jahreseinkommen 5.000 £ übersteigt.`,
  an_educational_institution_such_as_a_university_or_school: `Eine Bildungseinrichtung wie eine Universität oder Schule.`,
  an_entity_that_is_not_registered_or_regulated_for_example_clubs_societies_and_small_community_groups: `Eine Einheit, die nicht registriert oder reguliert ist. Beispielsweise Clubs, Gesellschaften und kleine Gemeinschaftsgruppen.`,
  a_type_of_charitable_organisation_registered_as_a_company_limited_by_guarantee: `Eine gemeinnützige Organisation, die als Company Limited by Guarantee oder in einer anderen gemeinnützigen Unternehmensform registriert ist. In Großbritannien sind sie beim Companies House als Company Limited by Gu registriert.`,
  organisations_that_are_responsible_for_the_provision_of_public_services: `Organisationen, die für die Bereitstellung öffentlicher Dienstleistungen verantwortlich sind.`,
  trustees: `Treuhänder`,
  please_provide_the_name_of_your_trustees_or_directors: `Bitte geben Sie den Namen Ihrer Treuhänder oder Direktoren an.`,
  a_minimum_of_two_is_required_only_1_is_required_if_you_are_a_uk_cic: `Es sind mindestens 2 erforderlich. Wenn Sie ein britischer CIC sind, ist nur 1 erforderlich.`,
  where_are_you_able_to_run_your_projects: `Wo können Sie Ihre Projekte durchführen?`,
  based_on_your_selections_we_will_be_able_to_recommend_relevant_new_funding_programmes_to_you: `Auf Basis Ihrer Auswahl können wir Ihnen relevante neue Förderprogramme empfehlen.`,
  countries_of_operation: `Einsatzländer`,
  within_your_selected_countries_can_you_run_projects_nationwide_or_in_specific_locations_only: `Können Sie in den von Ihnen ausgewählten Ländern Projekte landesweit oder nur an bestimmten Standorten durchführen?`,
  nationwide: `Bundesweit`,
  specific_locations: `Bestimmte Standorte`,
  please_describe_what_your_organisation_does: `Bitte beschreiben Sie, was Ihre Organisation macht`,
  please_provide_a_brief_overview_of_your_groups_purpose_aims_and_objectives: `Bitte geben Sie einen kurzen Überblick über den Zweck und die Ziele Ihrer Gruppe.`,
  social_media: `Soziale Medien`,
  please_share_a_link_to_your_website: `Bitte teilen Sie einen Link zu Ihrer Website`,
  if_applicable_please_share_your_social_media_links: `Geben Sie gegebenenfalls Ihre Social-Media-Links an`,
  please_add_your_entity_logo: `Bitte fügen Sie Ihr Unternehmenslogo hinzu`,
  please_upload: `Bitte laden Sie hoch`,
  your_profile_is_complete: `Ihr Profil ist vollständig`,
  you_can: `Du kannst`,
  edit_title_caption: `'Bearbeiten'`,
  your_profile_at_any_point_by_clicking_into: `Ihr Profil können Sie jederzeit ändern, indem Sie auf „Meine Organisation“ > „Profil“ > „Bearbeiten“ klicken.`,
  what_happens_next: `Wie geht es weiter?`,
  start_your_application: `Starten Sie Ihre Bewerbung`,
  if_you_accessed_bizGive_via_a_company_programme: `Wenn Sie über ein Unternehmensprogramm auf BizGive zugegriffen haben, klicken Sie auf „Bewerben“, um Ihr Bewerbungsformular zu starten.`,
  discover_company_programmes: `Entdecken Sie Firmenprogramme`,
  click_discover_to_view_and_apply_to_live_company_support_programmes: `Klicken Sie auf „Entdecken“, um aktuelle Unternehmensunterstützungsprogramme anzuzeigen und sich dafür zu bewerben.`,
  enter_url: `URL eingeben`,
  please_upload_documentation: `Bitte laden Sie die Dokumentation hoch`,
  council_or_government_linked_entity: `Rat oder regierungsnahe Einrichtung`,
  locations: `Standorte`,
  specific_locations_within_each_country: `Spezifische Standorte innerhalb jedes Landes`,
  entity_type: `Entitätstyp`,
  legal_name: `Gesetzlicher Name`,
  governing_documents: `Leitende Dokumente`,
  operating_location: `Betriebsstandort`,
  nationally_in_the_following_countries: `National in folgenden Ländern:`,
  locally_in_the_following_countries: `Lokal in folgenden Ländern:`,
  not_available: `Nicht verfügbar`,
  registration_number: `Registrierungsnummer`,
  trading_name: `Handelsname`,
  web_uri: `Web-URI`,
  registration_profile_url: `Registrierungsprofil-URL`,
  discover_funding_opportunities: `Entdecken Sie Finanzierungsmöglichkeiten`,
  available_programmes_filtered_by_your_entitys_area_of_operation: `Verfügbare Finanzierungen, die jetzt oder in Kürze verfügbar sind, gefiltert nach dem Tätigkeitsbereich Ihres Unternehmens:`,
  change_here: `Hier ändern`,
  programme: `Programm`,
  applications_accepted: `Bewerbungen akzeptiert`,
  decision_made: `Entscheidung getroffen`,
  location: `Standort`,
  action: `Aktion`,
  your_entity_type_is_not_supported_by_this_programme: `Ihr Entitätstyp wird von diesem Programm nicht unterstützt.`,
  please_click_ok_and_view_the_permitted_entities_in_the_programme_review_page: `Klicken Sie bitte auf „OK“ und sehen Sie sich die zulässigen Entitäten auf der Programmüberprüfungsseite an.`,
  content: `Inhalt`,
  supported_projects: `Unterstützte Projekte`,
  total_support: `Umfassende Unterstützung`,
  select_programme: `Programm auswählen`,
  select_report_type: `Berichtstyp auswählen`,
  enter_start_date: `Startdatum eingeben`,
  enter_end_date: `Enddatum eingeben`,
  report: `Bericht`,
  overdue: `Überfällig`,
  view_report: `Bericht anzeigen`,
  start_report: `Bericht starten`,
  complete_report: `Vollständiger Bericht`,
  add_your_profile_picture: `Fügen Sie Ihr Profilbild hinzu`,
  project: `Projekt`,
  registration_website: `Registrierungswebsite`,
  outside_of_impact_area: `Außerhalb des Aufprallbereichs`,
  this_interim_update_is_for: `Dieses Zwischenupdate ist für`,
  interim_update_deadline: `Frist für Zwischenaktualisierung`,
  form_guidance: `Formularanleitung`,
  in_the_form_you_will_be_asked_to_share_details_of_the_project_you_received_funding_for: `Im Formular werden Sie gebeten, Einzelheiten zu dem Projekt anzugeben, für das Sie eine Förderung erhalten haben.`,
  to_access_a_saved_interim_update_click_into_impact: `So greifen Sie auf ein gespeichertes Zwischenupdate zu: Klicken Sie auf Impact > Content > Complete Report`,
  to_access_a_saved_interim_update_click_into_impact_content: `So zeigen Sie ein übermitteltes Zwischenupdate an: Klicken Sie auf „Auswirkungen“ > „Inhalt“ > „Bericht anzeigen“`,
  interim_update: `Zwischenupdate`,
  below_is_the_support_you_requested_from_the_company_in_your_application: `Nachfolgend finden Sie die Unterstützung, die Sie in Ihrer Bewerbung vom Unternehmen angefordert haben.`,
  how_have_you_used_the_support_provided_so_far: `Wie haben Sie die Unterstützung bisher genutzt?`,
  are_there_any_changes_to_your_planned_expenditure_and_if_so_why: `Gibt es Änderungen bei Ihren geplanten Ausgaben und wenn ja, warum?`,
  are_there_any_changes_to_your_estimated_completion_date_and_if_so_why: `Gibt es Änderungen an Ihrem voraussichtlichen Fertigstellungstermin und wenn ja, warum?`,
  please_email_bizGive: `Bitte senden Sie eine E-Mail an BizGive`,
  if_there_is_a_substantial_change_to_your_completion_date_and_we_will_ensure_the_deadline_for_your_final_report_is_update: `wenn sich Ihr Abschlusstermin wesentlich ändert, und wir stellen sicher, dass die Frist für Ihren Abschlussbericht aktualisiert wird.`,
  share_images: `Bilder teilen`,
  please_upload_images_to_bring_your_project_to_life_this_significantly_increases_the_likelihood_of_the_company_sharing_your_content: `Bitte laden Sie Bilder hoch, um Ihr Projekt zum Leben zu erwecken. Dies erhöht die Wahrscheinlichkeit, dass das Unternehmen Ihre Inhalte teilt, erheblich.`,
  sends_your_form_to_the_company: `sendet Ihren Bericht an das Unternehmen. Diese Schaltfläche wird auf dem letzten Bildschirm des Formulars angezeigt.`,
  submit_your_report: `Senden Sie Ihren Bericht`,
  i_have_read_and_agree_to_the_above_terms: `Ich habe die oben genannten Bedingungen gelesen und stimme ihnen zu.`,
  add_files: `Dateien hinzufügen`,
  please_confirm_that_all_necessary_copyrights_and_acknowledgements_have_been_added: `Bitte bestätigen Sie, dass alle erforderlichen Urheberrechte und Anerkennungen hinzugefügt wurden.`,
  i_confirm_that_all_necessary_copyrights_and_acknowledgements_have_been_added: `Ich bestätige, dass alle erforderlichen Urheberrechte und Hinweise hinzugefügt wurden.`,
  final_report_deadline: `Frist für den Abschlussbericht`,
  please_press_add_to_save_the_invited_user: `Bitte drücken Sie „Hinzufügen“, um den eingeladenen Benutzer zu speichern`,
  inputs: `Eingänge`,
  did_any_of_your_plans_change: `Haben sich Ihre Pläne geändert?`,
  please_select_and_enter_your_final_inputs: `Bitte wählen Sie Ihre endgültigen Eingaben aus und geben Sie sie ein`,
  please_update_your_expenditure: `Bitte aktualisieren Sie Ihre Ausgaben`,
  please_update_the_items_or_services_you_used: `Bitte aktualisieren Sie die von Ihnen genutzten Artikel oder Dienste`,
  please_update_the_volunteering_support_you_used: `Bitte aktualisieren Sie die von Ihnen genutzte Freiwilligenunterstützung`,
  below_are_the_outputs_you_shared_in_your_application: `Nachfolgend finden Sie die Ausgaben, die Sie in Ihrer Anwendung freigegeben haben.`,
  did_your_outputs_change: `Haben sich Ihre Ausgaben geändert?`,
  please_update_your_outputs: `Bitte aktualisieren Sie Ihre Ausgaben`,
  your_outputs_will_show_like_this_in_your_report: `Ihre Ausgaben werden in Ihrem Bericht wie folgt angezeigt:`,
  i_acknowledge_the: `Ich erkenne die`,
  below_are_the_beneficiaries_you_shared_in_your_application: `Nachfolgend sind die Begünstigten aufgeführt, die Sie in Ihrem Antrag angegeben haben.`,
  did_your_social_beneficiary_types_change: `Hat sich Ihr Sozialleistungsempfängertyp geändert?`,
  please_update_your_social_beneficiary_types: `Bitte aktualisieren Sie Ihre Sozialleistungsempfängertypen`,
  did_your_social_beneficiary_numbers_change: `Hat sich Ihre Sozialhilfenummer geändert?`,
  please_update_your_social_beneficiary_numbers: `Bitte aktualisieren Sie Ihre Sozialhilfenummern`,
  did_your_environmental_beneficiaries_change: `Haben sich Ihre Umweltbegünstigten geändert?`,
  please_update_your_environmental_beneficiaries: `Bitte aktualisieren Sie Ihre Umweltbegünstigten`,
  below_are_the_objectives_and_outcomes_you_shared_in_your_application: `Nachfolgend finden Sie die Ziele und Ergebnisse, die Sie in Ihrer Bewerbung angegeben haben.`,
  objectives_n_outcomes: `Ziele und Ergebnisse`,
  were_you_successful_in_achieving_your_objectives_and_outcomes: `Konnten Sie Ihre Ziele erreichen und Ergebnisse erzielen?`,
  inputs_n_outputs: `Eingänge und Ausgänge`,
  case_studies: `Fallstudien`,
  preview_n_submit: `Vorschau und Senden`,
  impact_measures: `Wirkungsmaßnahmen`,
  the_company_has_requested_you_to_add_indicators_to_measure_the_progress_of_your_project: `Das Unternehmen hat Sie gebeten, Indikatoren hinzuzufügen, um den Fortschritt Ihres Projekts zu messen.`,
  general_indicators: `Allgemeine Indikatoren`,
  these_indicators_are_general_to_your_opportunity_or_entity_please_click_add_to_create_them: `Diese Indikatoren gelten allgemein für Ihre Opportunity oder Ihr Unternehmen. Klicken Sie auf „Hinzufügen“, um sie zu erstellen.`,
  indicator: `Indikator`,
  required: `Erforderlich?`,
  target: `Ziel`,
  final_title: `Finale`,
  status: `Status`,
  project_indicators: `Projektindikatoren`,
  the_indicators_below_are_linked_to_your_selected_objectives_and_outcomes_please_click_add_to_create_them: `Die folgenden Indikatoren sind mit Ihren ausgewählten Zielen und Ergebnissen verknüpft. Klicken Sie auf „Hinzufügen“, um sie zu erstellen.`,
  objective: `Objektiv`,
  outcome: `Ergebnis`,
  achieved: `Erreicht`,
  your_absolute_impact_is: `Ihre absolute Wirkung ist impactNumber`,
  your_relative_impact_is: `Ihre relative Auswirkung ist impactNumber`,
  case_studies_and_media: `Fallstudien und Medien`,
  case_studies_and_images_increase_the_likelihood_of_the_company_sharing_your_project_where_possible_please_share_a_case_study_and_at_least_one_image: `Fallstudien und Bilder erhöhen die Wahrscheinlichkeit, dass das Unternehmen Ihr Projekt teilt. Teilen Sie nach Möglichkeit eine Fallstudie und mindestens ein Bild.`,
  add_case_study: `Fallstudie hinzufügen`,
  add_images: `Bilder hinzufügen`,
  please_upload_this_file_type_in_the_add_files_section_below: `Bitte laden Sie diesen Dateityp im Abschnitt „Dateien hinzufügen“ weiter unten hoch.`,
  please_upload_images_in_the_additional_images_section_above: `Bitte laden Sie Bilder im Abschnitt „Zusätzliche Bilder“ oben hoch`,
  upload_any_image_files_here_png_jpg: `Laden Sie hier beliebige Bilddateien hoch, z. B. .png, .jpg`,
  upload_any_documents_that_you_wish_to_share: `Laden Sie alle Dateien hoch, die keine Bilder sind und die Sie teilen möchten. Beispielsweise docx, .pdf oder .xlsx oder Videos bis zu 50 MB.`,
  case_study_name: `Name der Fallstudie`,
  what_impact_did_your_project_have: `Welche Wirkung hatte Ihr Projekt?`,
  add_a_description: `Hinzufügen einer Beschreibung`,
  for_example_what_was_there_at_start_what_did_you_do_and_what_was_the_result: `Zum Beispiel: Was war am Anfang, was hast du gemacht und was war das Ergebnis?`,
  share_a_quote_such_as_from_a_beneficiary: `Teilen Sie ein Zitat, beispielsweise von einem Begünstigten`,
  quote_by: `Zitat von`,
  please_share_any_images: `Bitte teilen Sie alle Bilder`,
  what_happens_next_for_example_are_you_planning_to_develop_your_project_further: `Wie geht es weiter? Planen Sie beispielsweise, Ihr Projekt weiterzuentwickeln?`,
  if_you_would_like_to_share_anything_else_with_the_company_please_use_the_box_below: `Wenn Sie dem Unternehmen noch etwas mitteilen möchten, verwenden Sie bitte das Feld unten`,
  the_company_has_requested_some_additional_information: `Das Unternehmen hat einige zusätzliche Informationen angefordert.`,
  content_agreement: `Inhaltsvereinbarung`,
  view_agreement: `Vereinbarung anzeigen`,
  application_agreement: `Bewerbungsvereinbarung`,
  send_message: `Nachricht senden`,
  this_final_Report_is_for: `Dieser Abschlussbericht ist für`,
  company_questions: `Fragen zum Unternehmen`,
  next_steps: `Nächste Schritte`,
  additional_details: `Weitere Details`,
  objectives_and_outcomes: `Ziele und Ergebnisse`,
  planned: `Geplant`,
  actual: `Tatsächlich`,
  days: `Tage`,
  of_equivalent_value: `von gleichwertigem Wert`,
  case_study: `Fallstudie`,
  includes_changes: `Enthält Änderungen`,
  hundred_as_planned: `100 % wie geplant`,
  show_planned_efforts: `Geplante Aufwände anzeigen`,
  final: `Finale`,
  support_awarded: `Unterstützung vergeben`,
  password_reset_expired: `Passwort-Reset abgelaufen`,
  please_select_forgot_password_again_and_click_on_the_email_to_reset_your_password_within_fifteen_minutes: `Bitte wählen Sie erneut „Passwort vergessen“ und klicken Sie auf die E-Mail, um Ihr Passwort innerhalb von 15 Minuten zurückzusetzen.`,
  please_check_check_your_spam_folder_if_the_email_is_not_immediately_visible: `Bitte überprüfen Sie Ihren Spam-Ordner, wenn die E-Mail nicht sofort sichtbar ist.`,
  request: `Anfrage`,
  please_note_this_email_address_needs_to_match_the_address: `Bitte beachten Sie: Diese E-Mail-Adresse muss mit der Adresse übereinstimmen, an die Sie Ihre Einladung erhalten haben.`,
  an_access_email_has_sent_to: `Eine Zugangs-E-Mail wurde gesendet an:`,
  you_can_close_this_tab: `Sie können diese Registerkarte schließen.`,
  we_couldnt_find_your_email_address: `Wir konnten Ihre E-Mail-Adresse nicht finden. Bitte stellen Sie sicher, dass sie mit Ihrer Einladungs-E-Mail übereinstimmt.`,
  the_feedback_portal_link_has_now_expired: `Der Link zum Feedback-Portal ist jetzt abgelaufen.`,
  please_contact_your_programme_administrator_if_you_still_require_access: `Bitte wenden Sie sich an Ihren Programmadministrator, wenn Sie weiterhin Zugriff benötigen.`,
  verify: `Verifizieren`,
  the_email_address_entered_does_not_match_your_unique_link_please_ensure_it_is_the_same_as_your_invitation_email: `Die eingegebene E-Mail-Adresse stimmt nicht mit Ihrem eindeutigen Link überein. Stellen Sie sicher, dass sie mit Ihrer Einladungs-E-Mail übereinstimmt.`,
  email_entered: `E-Mail eingegeben`,
  try_again: `Versuchen Sie es erneut`,
  welcome_to_your_voting_panel: `Willkommen in Ihrem Abstimmungspanel!`,
  please_click_review_to_assess_each_application_and_then_cast_your_vote: `Klicken Sie bitte auf „Überprüfen“, um jede Bewerbung zu bewerten und geben Sie dann Ihre Stimme ab.`,
  please_enter_your_name: `Bitte geben Sie Ihren Namen ein`,
  registered_charity: `Eingetragene Wohltätigkeitsorganisation`,
  charitable_company: `Wohltätiges Unternehmen`,
  community_interest_company: `Unternehmen mit gesellschaftlichem Interesse`,
  charitable_trust: `Wohltätigkeitsstiftung`,
  for_profit_company: `Profitorientiertes Unternehmen`,
  academic_institution: `Akademische Einrichtung`,
  government_linked_entity: `Mit der Regierung verbundenes Unternehmen`,
  parish_or_community_council: `Pfarrgemeinderat`,
  please_upload_a_copy_of_your_governing_document1: `Bitte laden Sie eine Kopie Ihres Verwaltungsdokuments hoch`,
  please_upload_a_copy_of_your_governing_document2: `Bitte laden Sie eine Kopie Ihres Verwaltungsdokuments hoch`,
  please_upload_a_copy_of_your_governing_document4: `Bitte laden Sie eine Kopie Ihres Verwaltungsdokuments hoch`,
  insert_number: `Nummer einfügen`,
  bring_the_project_to_life_share_pictures_of_what_you_will_be_changing_or_plan_to_achieve: `Erwecken Sie das Projekt zum Leben. Teilen Sie Bilder von dem, was Sie ändern oder erreichen möchten.`,
  please_select_an_existing_user_or_invite_a_new_one: `Bitte wählen Sie einen bestehenden Benutzer aus oder laden Sie einen neuen ein.`,
  decisions_to_be_made: `Zu treffende Entscheidungen:`,
  please_add_at_least_one_criteria: `Bitte fügen Sie mindestens ein Kriterium hinzu`,
  see_full_report: `Vollständigen Bericht anzeigen`,
  internal_actions: `Interne Aktionen`,
  this_file_exceeds_the_limit_of_150mb: `Diese Datei überschreitet das Limit von 150 MB. Bitte verkleinern Sie die Datei oder wenden Sie sich an den BizGive-Support.`,
  country_af: `Afghanistan`,
  country_ax: `Åland-Inseln`,
  country_al: `Albanien`,
  country_dz: `Algerien`,
  country_as: `Amerikanisch-Samoa`,
  country_ad: `Andorra`,
  country_ao: `Angola`,
  country_ai: `Anguilla`,
  country_aq: `Antarktis`,
  country_ag: `Antigua und Barbuda`,
  country_ar: `Argentinien`,
  country_am: `Armenien`,
  country_aw: `Aruba`,
  country_au: `Australien`,
  country_at: `Österreich`,
  country_az: `Aserbaidschan`,
  country_bs: `Bahamas`,
  country_bh: `Bahrain`,
  country_bd: `Bangladesch`,
  country_bb: `Barbados`,
  country_by: `Weißrussland`,
  country_be: `Belgien`,
  country_bz: `Belize`,
  country_bj: `Benin`,
  country_bm: `Bermuda`,
  country_bt: `Bhutan`,
  country_bo: `Bolivien, Plurinationaler Staat`,
  country_bq: `Bonaire, Sint Eustatius und Saba`,
  country_ba: `Bosnien und Herzegowina`,
  country_bw: `Botswana`,
  country_bv: `Bouvetinsel`,
  country_br: `Brasilien`,
  country_io: `Britisches Territorium im Indischen Ozean`,
  country_bn: `Brunei Darussalam`,
  country_bg: `Bulgarien`,
  country_bf: `Burkina Faso`,
  country_bi: `Burundi`,
  country_cv: `Kap Verde`,
  country_kh: `Kambodscha`,
  country_cm: `Kamerun`,
  country_ca: `Kanada`,
  country_ky: `Kaimaninseln`,
  country_cf: `Zentralafrikanische Republik`,
  country_td: `Tschad`,
  country_cl: `Chile`,
  country_cn: `China`,
  country_cx: `Weihnachtsinsel`,
  country_cc: `Kokosinseln (Keelinginseln)`,
  country_co: `Kolumbien`,
  country_km: `Komoren`,
  country_cg: `Kongo`,
  country_cd: `Kongo, Demokratische Republik`,
  country_ck: `Cookinseln`,
  country_cr: `Costa Rica`,
  country_ci: `Elfenbeinküste`,
  country_hr: `Kroatien`,
  country_cu: `Kuba`,
  country_cw: `Curaçao`,
  country_cy: `Zypern`,
  country_cz: `Tschechien`,
  country_dk: `Dänemark`,
  country_dj: `Dschibuti`,
  country_dm: `Dominica`,
  country_do: `Dominikanische Republik`,
  country_ec: `Ecuador`,
  country_eg: `Ägypten`,
  country_sv: `El Salvador`,
  country_gq: `Äquatorialguinea`,
  country_er: `Eritrea`,
  country_ee: `Estland`,
  country_sz: `Eswatini`,
  country_et: `Äthiopien`,
  country_fk: `Falklandinseln (Malvinas)`,
  country_fo: `Färöer Inseln`,
  country_fj: `Fidschi`,
  country_fi: `Finnland`,
  country_fr: `Frankreich`,
  country_gf: `Französisch-Guayana`,
  country_pf: `Französisch-Polynesien`,
  country_tf: `Französische Südgebiete`,
  country_ga: `Gabun`,
  country_gm: `Gambia`,
  country_ge: `Georgia`,
  country_de: `Deutschland`,
  country_gh: `Ghana`,
  country_gi: `Gibraltar`,
  country_gr: `Griechenland`,
  country_gl: `Grönland`,
  country_gd: `Grenada`,
  country_gp: `Guadeloupe`,
  country_gu: `Guam`,
  country_gt: `Guatemala`,
  country_gg: `Guernsey`,
  country_gn: `Guinea`,
  country_gw: `Guinea-Bissau`,
  country_gy: `Guyana`,
  country_ht: `Haiti`,
  country_hm: `Heard Island und McDonald Islands`,
  country_va: `Heiliger Stuhl`,
  country_hn: `Honduras`,
  country_hk: `Hongkong`,
  country_hu: `Ungarn`,
  country_is: `Island`,
  country_in: `Indien`,
  country_id: `Indonesien`,
  country_ir: `Iran, Islamische Republik`,
  country_iq: `Irak`,
  country_ie: `Irland`,
  country_im: `Isle of Man`,
  country_il: `Israel`,
  country_it: `Italien`,
  country_jm: `Jamaika`,
  country_jp: `Japan`,
  country_je: `Jersey`,
  country_jo: `Jordanien`,
  country_kz: `Kasachstan`,
  country_ke: `Kenia`,
  country_ki: `Kiribati`,
  country_kp: `Korea, Demokratische Volksrepublik`,
  country_kr: `Korea, Republik`,
  country_kw: `Kuwait`,
  country_kg: `Kirgisistan`,
  country_la: `Demokratische Volksrepublik Laos`,
  country_lv: `Lettland`,
  country_lb: `Libanon`,
  country_ls: `Lesotho`,
  country_lr: `Liberia`,
  country_ly: `Libyen`,
  country_li: `Liechtenstein`,
  country_lt: `Litauen`,
  country_lu: `Luxemburg`,
  country_mo: `Macau`,
  country_mg: `Madagaskar`,
  country_mw: `Malawi`,
  country_my: `Malaysia`,
  country_mv: `Malediven`,
  country_ml: `Mali`,
  country_mt: `Malta`,
  country_mh: `Marshallinseln`,
  country_mq: `Martinique`,
  country_mr: `Mauretanien`,
  country_mu: `Mauritius`,
  country_yt: `Mayotte`,
  country_mx: `Mexiko`,
  country_fm: `Mikronesien, Föderierte Staaten von`,
  country_md: `Moldawien, Republik`,
  country_mc: `Monaco`,
  country_mn: `Mongolei`,
  country_me: `Montenegro`,
  country_ms: `Montserrat`,
  country_ma: `Marokko`,
  country_mz: `Mosambik`,
  country_mm: `Myanmar`,
  country_na: `Namibia`,
  country_nr: `Nauru`,
  country_np: `Nepal`,
  country_nl: `Niederlande, Königreich der`,
  country_nc: `Neukaledonien`,
  country_nz: `Neuseeland`,
  country_ni: `Nicaragua`,
  country_ne: `Niger`,
  country_ng: `Nigeria`,
  country_nu: `Niue`,
  country_nf: `Norfolkinsel`,
  country_mk: `Nordmazedonien`,
  country_mp: `Nördliche Marianen`,
  country_no: `Norwegen`,
  country_om: `Oman`,
  country_pk: `Pakistan`,
  country_pw: `Palau`,
  country_ps: `Palästina, Staat`,
  country_pa: `Panama`,
  country_pg: `Papua-Neuguinea`,
  country_py: `Paraguay`,
  country_pe: `Peru`,
  country_ph: `Philippinen`,
  country_pn: `Pitcairn`,
  country_pl: `Polen`,
  country_pt: `Portugal`,
  country_pr: `Puerto Rico`,
  country_qa: `Katar`,
  country_re: `Wiedervereinigung`,
  country_ro: `Rumänien`,
  country_ru: `Russische Föderation`,
  country_rw: `Ruanda`,
  country_bl: `Saint-Barthélemy`,
  country_sh: `St. Helena, Ascension und Tristan da Cunha`,
  country_kn: `St. Kitts und Nevis`,
  country_lc: `St. Lucia`,
  country_mf: `Saint Martin (französischer Teil)`,
  country_pm: `Saint-Pierre und Miquelon`,
  country_vc: `St. Vincent und die Grenadinen`,
  country_ws: `Samoa`,
  country_sm: `San Marino`,
  country_st: `São Tomé und Príncipe`,
  country_sa: `Saudi-Arabien`,
  country_sn: `Senegal`,
  country_rs: `Serbien`,
  country_sc: `Seychellen`,
  country_sl: `Sierra Leone`,
  country_sg: `Singapur`,
  country_sx: `Sint Maarten (niederländischer Teil)`,
  country_sk: `Slowakei`,
  country_si: `Slowenien`,
  country_sb: `Salomonen`,
  country_so: `Somalia`,
  country_za: `Südafrika`,
  country_gs: `Südgeorgien und die Südlichen Sandwichinseln`,
  country_ss: `Südsudan`,
  country_es: `Spanien`,
  country_lk: `Sri Lanka`,
  country_sd: `Sudan`,
  country_sr: `Suriname`,
  country_sj: `Spitzbergen und Jan Mayen`,
  country_se: `Schweden`,
  country_ch: `Schweiz`,
  country_sy: `Arabische Republik Syrien`,
  country_tw: `Taiwan, Provinz Chinas`,
  country_tj: `Tadschikistan`,
  country_tz: `Tansania, Vereinigte Republik`,
  country_th: `Thailand`,
  country_tl: `Timor-Leste`,
  country_tg: `Togo`,
  country_tk: `Tokelau`,
  country_to: `Tonga`,
  country_tt: `Trinidad und Tobago`,
  country_tn: `Tunesien`,
  country_tr: `Türkei`,
  country_tm: `Turkmenistan`,
  country_tc: `Turks- und Caicosinseln`,
  country_tv: `Tuvalu`,
  country_ug: `Uganda`,
  country_ua: `Ukraine`,
  country_ae: `Vereinigte Arabische Emirate`,
  country_gb: `Vereinigtes Königreich Großbritannien und Nordirland`,
  country_us: `Vereinigte Staaten von Amerika`,
  country_um: `Kleinere abgelegene Inseln der Vereinigten Staaten`,
  country_uy: `Uruguay`,
  country_uz: `Usbekistan`,
  country_vu: `Vanuatu`,
  country_ve: `Venezuela, Bolivarische Republik`,
  country_vn: `Vietnam`,
  country_vg: `Britische Jungferninseln`,
  country_vi: `Amerikanische Jungferninseln`,
  country_wf: `Wallis und Futuna`,
  country_eh: `Westsahara`,
  country_ye: `Jemen`,
  country_zm: `Sambia`,
  country_zw: `Simbabw`,
}

export default deLocale;
